module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong', [_vm._v("A")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Acaena")])]), _vm._v(" (a-sane' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("New Zealand Bur")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Rosaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Of the 100 species in this genus, we are lucky to see a half a dozen in even the better public gardens in North America. As the common name suggests, many species are native to New Zealand, including its namesake, "), _c('em', [_vm._v("A. novae-zelandiae")]), _vm._v(". Other common names for this plant are much more alliterative and any plant with names like pirripirri bur, bidgee-widgee and biddy biddy is probably worth the price of purchase alone. The excellent plantings one sees in New Zealand and throughout the British Isles have not made the transition to the North American garden particularly well. Being native to New Zealand generally equates to sure and rapid death for eastern and southern gardeners, but a reasonable chance of success for West Coasters. Nevertheless, where conditions are favorable, the dense, 2-3\" tall mat-forming plants make attractive ground covers and are highly sought after.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some gardeners find them a little too aggressive (some lucky gardeners call them thugs), as plants can take over significant areas of the rock garden or small border. They root at the nodes and are excellent for placing between stepping stones or trailing over walls. All species prefer full sun, although "), _c('em', [_vm._v("A. microphylla")]), _vm._v(", rosy-spined New Zealand bur, "), _c('em', [_vm._v("A. inermis")]), _vm._v(", spineless acaena, and its cultivar ‘Purpurea’ and "), _c('em', [_vm._v("A. myriophylla")]), _vm._v(", fern-leaved New Zealand bur, are more shade tolerant than others. All species prefer low humidity and excellent drainage and are cold hardy to about 10°F (zones 7-8), although some sources have them hardy to zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In general, the flowers are not particularly noticeable, being small, greenish and lacking petals (apetalous). However, the pea-green to steel-blue leaves are pinnately compound and often finely serrated, and colorful bur-like fruit (achenes) keep gardeners wanting more. The burs are carried well above the foliage and are the most interesting part of the plants. Most leaves are about 2\" long but "), _c('em', [_vm._v("A. myriophylla")]), _vm._v(" has 6-8\" long green leaves with 15-17 leaflets with burs held at the end of the 6-9\" flower stems. The spherical burs are often spiny and brightly colored relative to the foliage.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("The more “burs” I see, the more I would like to see selection work done to enhance their tolerance to “real” weather. Hardiness is always a topic of discussion for those few people who know about these plants. Most books suggest zone 7 for cold hardiness, but Arrowhead Alpines in Fowlerville, Michigan (zone 5) says that "), _c('em', [_vm._v("A. inermis")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("‘Purpurea’ is “hardy and nearly indestructible here”. ‘Blue Haze’ seems to be fairly tolerant, but I have managed to kill it in my Athens garden. The vigor of "), _c('em', [_vm._v("A. fissistipula")]), _vm._v(" is well known and if crossed with blue foliage forms might provide some potentially tough, handsome offspring. Many other combinations await the bur breeder.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is usually by division, but cuttings and seed are also used. Seed should be sown in open containers in the fall, and placed in cold frames over winter.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("anserinifolia")])]), _vm._v(" (an-sir-in-i-foe' lee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Bronze Pirri-Pirri Bur")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4\"/10\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7b-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species bears dull green hairy leaves which are paler green beneath, and bronze or red fruit. Five to eight pairs of leaflets are tinged with pink and the combination is handsome indeed. The species is seldom offered but ‘Bronzette’, a cross with "), _c('em', [_vm._v("A. novae-zelandiae")]), _vm._v(", is occasionally found. Plants have bronze fruit and green-bronze foliage and grow about 6\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("microphylla")])]), _vm._v(" (mike' ro-fil-ah)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rosy-spined New Zealand Bur")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dull Rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The short plant has small silver-blue to blue-green compound leaves with a strong hint of copper and makes an exceptionally good ground cover. The flowers are rather forgettable but the handsome pink to rosy red fruit, nearly an inch across, looks like a spiny wicked thing, but is in fact quite soft. Plants are a little more cold hardy and more tolerant of poorly-drained soils than other species. If conditions are right, it can be quite aggressive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Copper Carpet’ is about 2\" tall with copper-bronze foliage and showy red burs.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pewter Carpet’ is similar to the above but with a dull glaze to the foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pulchella’ is about 4\" tall, with coppery foliage bearing hints of silver. The fruit is reddish-brown.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. buchananii")]), _vm._v(" is sometimes offered by specialist nurseries and bears pea-green, 3\" long leaves and amber burs. The leaflets, which occur in 3-6 pairs, are about an inch long and have soft silky margins on the underside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. inermis")]), _vm._v(" produces mats of low-growing foliage but has a smooth, rather than a spiny bur. Less fun, but more huggable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. saccaticupula")]), _vm._v(" ‘Blue Haze’ is still one of the most popular cultivars for the bur gardener. The leaves are a beautiful glaucous blue and the brownish red flowers and red fruit are handsome as well. Plants are 2-4\" tall, spread well, and make attractive ground covers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Confusion")]), _vm._v(":")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I often confuse plants of "), _c('em', [_vm._v("Acaena")]), _vm._v(" with "), _c('em', [_vm._v("Leptinella")]), _vm._v(" (which see), known as brass buttons, particularly when flowers or fruit are not present. They are both low, fernlike ground covers, both can have dark green foliage and both are made for rock gardens ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("and even for walking upon. The flowers and fruit however are obviously different; "), _c('em', [_vm._v("Acaena")]), _vm._v(" is grown for the large ornamental fruit and not the rather inconspicuous flower, while "), _c('em', [_vm._v("Leptinella")]), _vm._v(" is grown for the opposite reasons, the fruit is unexciting. They are in very different families and are not really confusing if they are seen together in flower, but let’s get real here, do you really think anyone actually plants burs and buttons together?")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Acantholimon")])]), _vm._v(" (a-kanth-o-lee' mon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Prickly Thrift")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Plumbaginaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("This large group of plants (about 120 species) occurs predominantly in rocky, high altitude habitats and thus you would not expect to see grand swaths in St. Louis or Atlanta. The genus, however, has a loyal, if small, following among gardeners. Plants are becoming better known in the North where rock gardens and alpine gardens are reasonably common. They are evergreen and grow in dense clumps of short, prickly 3-angled narrow leaves. They look like they belong more to the cactus family than the plumbago family, that is, until they flower, at which time the resemblance to the latter is obvious. To be brutally honest, when not in flower, plants resemble green hedgehogs stuck in the middle of a garden. They are slow growing, but when they produce those long-lasting sprays of small pink flowers, they can be quite irresistible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are well known by alpine enthusiasts but alpine people are by definition somewhat strange, so this should not be surprising. While these plants will always be thought of as weird, they should be looked upon by other gardeners as exceptionally good subjects for the xeric garden. They need to be used far more often in areas of low rainfall and poor soils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is still difficult to find "), _c('em', [_vm._v("Acantholimon")]), _vm._v(" in the trade and gardeners are often forced to raise plants from seeds or softwood cuttings. However, hope is on the way, as species such as "), _c('em', [_vm._v("A. glumaceum")]), _vm._v(", with bright rosy pink flowers, "), _c('em', [_vm._v("A. olivieri")]), _vm._v(", with whitish pink flowers held well above the mat, and "), _c('em', [_vm._v("A. ulicinum")]), _vm._v(", with hot pink flowers, are becoming better known. One nursery provides 6 distinct taxa while another lists 20 taxa of "), _c('em', [_vm._v("Acantholimon")]), _vm._v(", once again verifying that there is simply no accounting for taste in American gardening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cuttings can be gingerly obtained from other enthusiasts. They can be painful, so root with care. Rooting near the base of the plant is encouraged by spreading sand around the base.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All species need gritty soils but may be grown on dry stone wall, gravel beds or sunny slopes with stony soils. Areas of high rainfall may not be a problem as long as drainage is impeccable. Full sun and cool nights are necessary. An excellent collection is in the alpine garden at the Denver Botanic Garden, but private collections are also well worth searching out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Acanthus")])]), _vm._v(" (a-kanth' us)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Bear’s Breeches")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Acanthaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The genus contains approximately 30 species of which three or four are particularly ornamental, providing foliage of great beauty and statuesque flowers. The basal leaves are simple, opposite, and often have soft, thorny margins. The flowers are held in long, ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("erect spikes and each flower is subtended by a showy, spiny, leaflike bract. The spikes are lovely, albeit somewhat unnerving, but the true ornamental value of the genus resides in the handsome foliage. Once established, "), _c('em', [_vm._v("Acanthus")]), _vm._v(" is almost indestructible and will colonize an area with its invasive roots. If one tires of bear’s breeches and wishes to remove same, it is next to impossible not to leave some root pieces behind, which, like amoebae, will regenerate and recolonize their old homesite.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I have always wondered where the name bear’s breeches came from, for the combination of the two words makes no sense at all, and it is difficult to even imagine a pair of bear’s breeches. Nowhere could I find an explanation, therefore I felt much better when I learned that the eminent British horticulturist Graham Stuart Thomas was equally stumped. He contacted Professor William Stearn who shed some possible light on the subject. Professor Stearn believed that the term resulted from a confusion of the medieval Latin description “"), _c('em', [_vm._v("branca ursina")]), _vm._v("”, meaning bear’s claw. The upper part of the hooded flower, upon proper squinting, could be said to resemble a bear’s claw. But the breeches, where did they come from? Madame Audrey Serreau, a gardener from Pultiers, France, believes that additional confusion between two Latin words resulted in the “breeches”. The word “branca” which means claw, was confused with the old Gaul word “braca” which later became “braies” and finally “breeches”. Is this clear yet? Such explanations may be confusing in themselves, however, as Madame Serreau stated, “Isn’t it fascinating to reflect upon such word changes, bringing, as they do across the centuries, echoes of long-silenced voices?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Acanthus")]), _vm._v(" is popular throughout the country although most authors state that it is insufficiently hardy for much of the North. Those authors need to see the wonderful plantings in Gardenview, Henry Ross’s fine horticultural park in Strongsville, Ohio (zone 6). And if they need other proof of toughness, they should visit the wonderful garden of Dale and Lila Critz in Savannah, Georgia, where heat, humidity and acanthus are all doing well. Persistent, long-lived and certainly weather hardy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are hardier than the flowers, and foliage may survive in particularly cold winters, but plants may not flower. Plants do well in full sun or partial shade and are relatively drought resistant although leaves will wilt often. Poor drainage is synonymous with poor performance and death. The foliage is occasionally evergreen in the South, but in severe winters becomes tattered and torn. In the North, plants are deciduous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most effective means of propagation is by 2-3\" long root cuttings taken in the spring. Insert vertically in a well-drained medium and keep moist and warm. Shoots appear in 3-5 weeks. In the garden, I can attest to the wonders of my handy-dandy tiller, with which I inadvertently tilled up a dormant patch of "), _c('em', [_vm._v("A. spinosus")]), _vm._v(". Next spring, every little mangled piece had sprouted. Plants may also be divided in early spring but adequate moisture is necessary to insure establishment. Fresh seed germinates in about 3 weeks if kept moist and warm (70-75°F).")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Acanthus Species")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Leaves spiny")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Leaf color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. caroli-alexandri")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("15-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. dioscoridis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. hungaricus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("30-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. mollis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("30-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. spinosus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("36-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark green")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-hungaricus")])]), _vm._v(" (hun-gar' i-cus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Balkan Bear’s Breeches")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("36-60\"/36\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Balkan Countries, Romania")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sold under the names of "), _c('em', [_vm._v("A. balcanicus")]), _vm._v(" and "), _c('em', [_vm._v("A. longifolius")]), _vm._v(", plants are also similar in habit and flower to "), _c('em', [_vm._v("A. mollis")]), _vm._v(". The dull green leaves are lobed with wide gaps between the lobes (the gap is referred to as a sinus). The sinuses are connected to each other with a flange of leaf parallel to the midrib. The sinuses are deep and the lobes are tapered at the base, characteristics which distinguish it from "), _c('em', [_vm._v("A. mollis")]), _vm._v(". The flower stems rise an additional 3-4' and bear numerous white and purple flowers in mid to late summer. The bracts surrounding the flowers have 5-7 veins and are painfully sharp. Plants are taller than most species, and the leaves more deeply cut. The foliage is more winter hardy than the flowers. After particularly cold winters, the leaves may emerge in the spring but no flowers may occur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants perform well in most gardens and since they are native to the Balkans, Romania and northern Yugoslavia, are probably the most cold hardy. They also perform better in southeastern gardens than "), _c('em', [_vm._v("A. mollis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-mollis")])]), _vm._v(" (mol' lis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Bear’s Breeches")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("30-48\"/36\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the fifth century B.C., one of the species of "), _c('em', [_vm._v("Acanthus")]), _vm._v(" was immortalized in the design of the sculptured leaves on Greek Corinthian columns. Some historians believe the design to be based on this species, others believe it is based on the foliage of "), _c('em', [_vm._v("A. spinosus")]), _vm._v(". The lustrous green, 8-12\" wide foliage is lobed but not as deeply as "), _c('em', [_vm._v("A. hungaricus")]), _vm._v(". Although small, soft spines are borne at the end of the lobes, the foliage does not feel at all spiny. The flowers are similar to those of "), _c('em', [_vm._v("A. hungaricus")]), _vm._v(". The plants, having a spread of up to 3', are best used as specimens or in groups of 3 to 5 plants. I have grown a number of species in the heat of north Georgia (zone 7b) and this one has flowered poorly. The magnificent plantings seen in southern California can not be duplicated in hot, humid weather.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Albus’ has mostly white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hollard’s Gold’ was originally sold in this country in 1994. The foliage is chartreuse; not bright enough to brag on its beauty but yellow enough to think about a need for fertility. Nevertheless I like this plant, even though it is not as vigorous as the species and tends to disappear in inclement conditions, like my garden. Plants are often sold as ‘Fielding Gold’, as it originally came from Fielding, New Zealand.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("latifolius")]), _vm._v(" is most common although less free flowering than the species. Plants bear 3-5' tall stalks of mauve-pink flowers and glossy green arching leaves which are sometimes scarcely dissected. Plants appear to be more robust and more cold tolerant than the species. There are a number of similar forms, and plants are often classified as Laterifolius Group.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rue Ledan’ was found in Matignon, France in the early 1990s. It is an excellent cultivar growing about 3' tall and producing shiny green leaves. The flowers are white rather than purple, and essentially sterile. It likely belongs to the Laterifolius Group.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tasmanian Angel’ is the first variegated acanthus and should be a hit. Plants also produce really wonderful pink and cream colored flowers on 4' tall stems. The foliage is unique in that the leaves have creamy yellow irregular margins. During the summer, the leaves may revert to green.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-spinosus")])]), _vm._v(" (spine-o' sus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spiny Bear’s Breeches")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("36-48\"/36\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mauve")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-10")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main difference between this species and the previous is the presence of spiny leaf margins which look a good deal more lethal than they really are. The 10\" diameter leaves are lanceolate, and more deeply divided than those of "), _c('em', [_vm._v("A. mollis")]), _vm._v(". The flowers are similar except that three to four veins occur on the purplish bracts rather than five to seven found in common bear’s breeches. If late freezes occur, "), _c('em', [_vm._v("A. mollis")]), _vm._v(" is killed to the ground while this species is little affected. The flowers are produced consistently each year and the leaves remain fresh all season. Plants also tolerate warm, humid summers better than the previous species, a definite advantage for southern gardeners.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lady Moore’ is an interesting plant occasionally seen in the British Isles but seldom in the United States. The foliage is creamy white in the spring, greening up as the weather warms up. Named for the wife of Sir Frederick Moore, former keeper of the Botanic Gardens at Glasnevin, Dublin.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("var. "), _c('em', [_vm._v("spinosissimus")]), _vm._v(" can be a man-eater but taxonomists have placed other plants in this group, diluting the pain. Originally plants bore leaves which were more sharply cut than those of the species, and enjoyed only by masochists or those who could command someone else to handle such vicious plants. I have enough trouble with ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("belligerent people, why tolerate belligerent plants? Today, sufficient variation is thought to exist among plants and they are now referred to as the Spinosissimus Group.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. caroli-alexandri")]), _vm._v(" has borne other names ("), _c('em', [_vm._v("A. syriacus")]), _vm._v("), but if you want a shorter classy plant, look for this species. Plants grow only about 18\" tall and bear typical white and purple flowers. However, the leaves are deeply cut and the tips can be spiny. The bracts beneath the flowers are also painful. Nevertheless, this is an excellent selection for a smaller garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. dioscoridis")]), _vm._v(" is 1-2' tall and has rosy pink bracts. The lanceolate leaves are petioled, gray green, and in var. "), _c('em', [_vm._v("dioscoridis")]), _vm._v(" are usually entire, perhaps with a few shallow lobes. Good drainage is essential. Native to mountainous areas of Asia Minor, it is likely hardy in zones 6-9, although not enough plants have been evaluated to provide confident hardiness ratings. var. "), _c('em', [_vm._v("perringii")]), _vm._v(" is more common, bearing deeply cut, almost spiny leaves and with more pink in the bracts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Summer Beauty’ is likely a hybrid between "), _c('em', [_vm._v("A. mollis")]), _vm._v(" and "), _c('em', [_vm._v("A. spinosus")]), _vm._v(". The leaves are more deeply cut than "), _c('em', [_vm._v("A. mollis")]), _vm._v(" but are still shiny and handsome. The plants are vigorous, 4-5' tall and bear white flowers with purple bracts. This is far superior than either of the parents, and I rate it highly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Achillea")])]), _vm._v(" (a-kill' ee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Although there are approximately 100 species, fewer than a dozen are truly ornamental. They range in height from four inches ("), _c('em', [_vm._v("A. nana")]), _vm._v(") to four feet ("), _c('em', [_vm._v("A. filipendulina")]), _vm._v(") and provide flowers of almost every hue. Leaves of all species are alternate and, with the exception of "), _c('em', [_vm._v("A. ageratum")]), _vm._v(", sweet yarrow, and "), _c('em', [_vm._v("A. ptarmica")]), _vm._v(", sneezewort, the foliage is deeply divided into a fine fernlike appearance. In several species, the foliage has a heavy spicy odor and a gray-green tint. A member of the aster family, its heads are made up of two distinct types of flowers. The outer ray flowers are pistillate (female only), and may be yellow, white, or pink while the inner disc flowers are bisexual (male and female together), and usually yellow. The flower heads (inflorescences) look like small table tops called corymbs. Another advantage of growing yarrow is the gardener’s ability to cut the flowers and enjoy them indoors. The flowers of most species make excellent fresh or dried specimens but the pollen must be visible before the flowers are cut or vase life will essentially be nil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some yarrows are at times considered weeds, particularly those which multiply rapidly from invasive rhizomes. This characteristic, however, is true for only one or two species; most others behave themselves and stay at home. Unless otherwise noted, all species should be grown in full sun and well-drained soils. They tolerate poor, slightly acid soils (if well-drained), although "), _c('em', [_vm._v("A. clavennae")]), _vm._v(" performs well in limey soils. Do not fertilize yarrows heavily; many of the upright species will grow too tall and lanky if fertilized or grown in rich soil.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Achillea Species")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Foliage color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". ‘Coronation Gold’")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. filipendulina")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-5")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. grandifolia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. millefolium")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink, red")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". ‘Moonshine’")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Sulphur")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ptarmica")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tomentosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-1")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-‘Coronation Gold’")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Coronation Gold Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid origin")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This hybrid was first offered in 1953 by Miss Pole of Lye End Nursery in southern England to commemorate the coronation of Elizabeth II. An amateur hybridizer, she crossed "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(" with "), _c('em', [_vm._v("A. clypeolata")]), _vm._v(", a small yellow-flowered species, to raise the best upright golden yellow yarrow available at that time, and arguably, still the best today. Plants were subsequently sold and distributed by Blooms of Bressingham of Diss, England and rapidly became popular throughout the world. It is sometimes incorrectly listed as a cultivar of fern-leaf yarrow, "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(", but that is unfair to this excellent hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plant is shorter than "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(", better branched, and does not require staking. It requires less maintenance and should be the plant of choice for landscapers. The inflorescences are 3-4\" across and look like shiny golden plates. Flowering begins in late May in north Georgia, June in the Northeast, late June in the Midwest, and continues for 8-12 weeks. The foliage is gray-green and has a strong aromatic smell. It tolerates a wide range of climates and soils and is grown in gardens from Manitoba to Florida.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Coronation Gold’ is also popular as a cut flower throughout the world. It is interesting to note the differences in stem and flower size between northern and southern climates. In north Georgia, over 50 flowering stems per plant were produced while the same plants growing in Holland yielded fewer than 15 stems but each one was 1 1/2-2 times longer with larger flowers. Propagate by terminal cuttings in spring or early summer, or by spring or fall division every 3-4 years. Stay away from seed labeled ‘Coronation Gold’; it will likely be "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(" or one of its cultivars.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-filipendulina")])]), _vm._v(" (fi-li-pen-dew' lye-na)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fern-leaf Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Caucasus")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The foliage is deeply cut and feathery but bears little of the gray-green tint that is so appealing in ‘Coronation Gold’. In general, foliage is greener, flowers are larger and plants are taller than those of ‘Coronation Gold’. This is a wonderfully handsome plant but when grown in rich soils, warm temperatures or over-fertilized, it ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("generally requires staking, a job most sane people view with disdain. The flat yellow flower heads are 3-4\" across and make excellent cut flowers. Provide full sun. Yellow-flowered yarrows combine well with pink phlox, purple-foliaged plants, blue delphiniums and red hot pokers.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea filipendulina")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Plants may be propagated by spring division, terminal cuttings in early summer, or by seed. Seed sown in a mixture of 1:1 peat:vermiculite and placed at 70-72°F in a humid area germinates within 21 days. Most cultivars are available from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Altgold’ stands about 3' tall and bears deep yellow flowers in late spring and again in early fall. An interesting rebloomer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cloth of Gold’ bears large pure yellow flowers and grows 3-4' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flowers of Sulphur’ is a 2' tall, slow-spreading hybrid of "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(" and "), _c('em', [_vm._v("A. ptarmica")]), _vm._v(". One of the best sulphur-colored flowers in the genus.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gold Coin’ is a dwarf form of ‘Parker’s Variety’, and grows only about 15\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gold Plate’ has deep yellow flowers on stems up to 5' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Parker’s Variety’ bears golden yellow flowers on 3-4' tall stems. This one and ‘Gold Plate’ produce large numbers of flowers and have better stem strength than the species but may require support in areas with hot, humid summers.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("‘Schwellenburg’ is likely a hybrid with "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(" and a yet to be determined species. The golden flowers sit atop silvery, ferny foliage and stand 1 1/2-2' tall. Plants do not appear to be particularly vigorous or tolerant of adverse weather, however if old flowers are removed and plants are not over-fertilized, better results can be expected.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-millefolium")])]), _vm._v(" (mil-lee-fo' lee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/5'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White to Cerise Red")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Common yarrow is “common” because of its ability to spread rapidly and take over any ground available. Often seeded as a wildflower on roadsides, the ferny foliage and off-white flowers fill in median strips and combine well with other roadside plants such as bachelor’s buttons and poppies. In Europe, it is often discarded as a troublesome weed not to be included on the grounds of any self-respecting gardener. Yet the same people will find fresh and dried flowers of common yarrow in florist ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("shops where they are widely used in colorful bouquets. The species was cultivated in Europe before 1440, used as a remedy for toothache, and mixed in ale in place of hops to increase the inebriating quality of that drink. It was thought to have a magical quality similar to our “apple a day keeps the doctor away”; and was said to grow in churchyards as a reproach to the dead, “who need never have come there if they had taken their yarrow broth faithfully every day while living”. The main use, however, was that of an herb to heal wounds. The genus was named after Achilles, who is said to have used "), _c('em', [_vm._v("A. millefolium")]), _vm._v(" to staunch the wounds of his soldiers, thus acquiring the common name of soldier’s woundweed and woundwort. And everyone thought this was just a common old flower!")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea millefolium")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("The habit is matlike and the dark green foliage is deeply cut. In early summer, the flower stalks rise about two feet and are quite strong where night temperatures consistently stay below 70°F. Where night temperatures are too warm, the stems do not acquire enough carbohydrates to “fatten up” and topple. Plants fill in rapidly and those placed four feet apart produce an unbroken mat in 2 years. If planted two feet apart, they fill in by the end of the first year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of cultivars are offered from seed but it is just as easy to divide good specimens to retain the desired colors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some of the following are selections of "), _c('em', [_vm._v("A. millefolium")]), _vm._v(", many are hybrids. Most of the hybrids are of questionable parentage but all have "), _c('em', [_vm._v("A. millefolium")]), _vm._v(" in them. The Galaxy hybrids ("), _c('em', [_vm._v("A. aegyptiaca")]), _vm._v(" var. "), _c('em', [_vm._v("taygetea")]), _vm._v(" (formerly "), _c('em', [_vm._v("A")]), _vm._v(". ‘Taygetea’) x "), _c('em', [_vm._v("A. millefolium")]), _vm._v(") have similar foliage to that of "), _c('em', [_vm._v("A. millefolium")]), _vm._v(" but the flower heads are larger and the stems much stronger. The only problem I have seen is the tendency of the flowers to fade, particularly when temperatures are above 80°F. In our trials in north Georgia, ‘Beacon’ and ‘Great Expectations’ faded less than others. In climates with cool night temperatures, little fading is seen.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Appleblossom’ is a vigorous 3' tall plant with peach to lilac-pink flowers. A Galaxy hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Apricot Beauty’ is likely a hybrid. It is difficult to find in this country but with its flat-topped soft yellow to apricot flower heads, it should be more common.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Apricot Delight’, ‘Strawberry Seduction’, and ‘Wonderful Wampee’ are part of the Tutti-Frutti series of seed-grown yarrows, designed primarily for rapid greenhouse production. And, no, I have no idea what they were smoking when these names were selected. Flower colors are light apricot, rose and light pink, respectively. All stand 12-20\" tall, the former being the shortest and the seducer being the tallest.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Belle Epoque’ has dusky pink flowers and gray green leaves. Plants earned an Award of Garden Merit (1999) from the Royal Horticultural Society.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Borealis’ (var. "), _c('em', [_vm._v("borealis")]), _vm._v(") bears dense clusters of rose-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cassis’ is about 2' tall with flat heads of cherry-red flowers. Plants bloom first year from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cerise Queen’ is one of the oldest and still popular cultivars. Plants are grown for the cerise-red flowers. It grows about 18\" tall and provides bright drifts of color.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea Galaxy hybrid")])]), _vm._v(" "), _c('p', {
    staticClass: "bibp"
  }, [_vm._v("‘Chamois’ has interesting tan-colored flowers (like a chamois?) which fade somewhat to a creamy yellow. Sounds awful, but not so bad.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Christel’ is a relatively new hybrid, with deeper green foliage than most “millefolium” forms. The flowers are deep rose-pink and if cut back may rebloom.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Christine’ has fernlike foliage, grows about 2' tall and is topped with light rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Citronella’ bears butter yellow flowers on an erect habit.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Colorado mix is grown from seed and provides flowers in a wide range of colors, including apricot, pink, red, russet, yellow, apricot, pink, and cream.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Creamy’ bears large heads of creamy-yellow flowers. Plants fill in quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Credo’ was bred in Germany, resulting from "), _c('em', [_vm._v("A. filipendula")]), _vm._v(" x "), _c('em', [_vm._v("A. millefolium")]), _vm._v(". It is a tall (3-4') cultivar with light yellow flowers that tend to fade to creamy-white. Good for cut flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Debutante’ is a mixture of plants, bearing rose to creamy white flowers. ‘Pink Debutante’ is also an excellent selection.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fire King’ and ‘Fire Beauty’ have dark red flowers; there is little difference between them.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("‘Fireland’ opens red then fades to pink and finally to a tawny gold. The plants grow about 3' tall but the stems are reasonably stout.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Great Expectations’ (‘Hope’) produces primrose yellow flowers on 2' high stems. A Galaxy hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Heidi’ has pastel pink flowers on 20\" stems in the spring and reblooms a little later in the summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hidden Pond Pink’ is a silly name for a pink-flowered, relatively short (15-24\") yarrow.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Island Pink’ has deep pink flowers and a deep green foliar color.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jambo’ bears medium yellow flowers on 15-18\" tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jungfrau’ has pastel yellow, almost white, flowers on 15\" plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kelwayi’ bears magenta-red flowers on 18\" stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lansdorferglut’ is an ugly name for a pretty 2-3' tall plant with soft pink flowers in flattened heads. Good for cutting.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lilac Beauty’ produces lilac flowers on strong upright stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lilac Queen’ has flat heads of pastel lilac flowers and is offered occasionally by mail order nurseries.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lusaka’ has white flowers and is a vigorous grower. ‘Madelein’ bears apricot colored flowers on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Martina’ has large, flat yellow flower heads on 2-2 1/2' tall stems. The foliage is ferny and green.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Marmalade’ has flowers in autumn colors of dark yellow and orange.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mary Ann’ bears lemon-yellow flowers over silvery-gray foliage and grows only about a foot tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Maskarade’ produces interesting pale yellow flower heads with red flecks along the edges as they mature. Quite a different look.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Moneymaker’ has salmon-pink flowers. I’m not sure where the money will be made, as there are many others with similar flower color as well.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nakuru’ produces purple and white bicolor flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Natalie’ is 2-3' tall with light pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Orange Queen’ has unusual orange-gold flowers. About 30\" tall and 18\" wide.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Paprika’ produces red and yellow flowers on a flattened inflorescence. One of the most handsome cultivars available.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Petra’ resulted from a cross between ‘Credo’ and ‘Fanal’. Plants bear fiery red flowers and stand about 20\" tall. Plants are unique because they are sterile and no wishy-washy seedlings will sneak into the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Proa’ is similar to, if not the same as, the white yarrow that has become naturalized along roadsides in this country. Plants were originally selected for high oil content of the seeds. A pretty enough plant, but quite aggressive.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Oertel’s Rose’ was introduced by Goodness Grows Nursery in Lexington, Georgia and blooms heavily with rosy pink and white flowers. A terrific selection for Southern gardeners.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Beauty’ bears 2' tall cerise-red flowers in midsummer.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("‘Red Velvet’ has dark red to rosy red flowers on 18-20\" tall plants. Supposedly the flowers do not fade during the summer, but I have not be able to verify that, at least in zone 7.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Richard Nelson’ was selected at Bluestone Nursery in Madison, Ohio, for its handsome pale pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rose Beauty’ has rather nondescript rose-pink flowers on 2' tall stems. This name is also used with var. "), _c('em', [_vm._v("roseum")]), _vm._v(", and includes pink seedlings in general.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rougham series of yarrows were developed at Rougham Hall Nursery, Rougham, Suffolk, England. They are about 2' in height and separate colors are available. ‘Rougham Beauty’ is light pink, ‘Rougham Bright Star’ is cherry-rose with a white eye, ‘Rougham Cream’ is an off-white, ‘Rougham Salmon’ is just that, ‘Rougham White’ is a cleaner white than most white yarrows. Plants do not seem to fade as badly as many others.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Salmon Beauty’ bears large heads of salmon flowers on 3' tall stems. A Galaxy hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sawa Sawa’ bears lavender-purple flowers on 20\" stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Schneetaler’ is a hybrid with pure white flowers. Plants are good for cut flowers and may rebloom if cut back hard after the initial bloom.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Sport’ is a vigorous grower with dark green foliage and dozens of clean white flowers on 18\" tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Summer Berries’ is a seed strain introduced in 2003. Pastel flower colors range from pink to light salmon to cherry.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Summer Pastels’ is a seed-propagated hybrid, which includes numerous pastel colors (pink, rose, lavender, salmon to orange) on 2' tall plants. Plants flower the first year from seed. The yellow hues are particularly good.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Summer Wine’ is taller than 3' and is used as a cut flower commercially. The bright wine red flowers are immediately visible, however they fade as they age to a rose pink color. This is not all bad as it provides some color contrast over the season.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Terracotta’ is an exceptional selection, with 2-3' tall plants of the finest salmon to peach colors I have seen. The foliage has a little silver hue to it as well. Its only drawback is that it may become too tall in rich soils or in areas with warm nights.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tickled Pink’ is a cute name for a seed-propagated mix of pink to rose colored flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Beacon’ stands 2-3' tall and bears rich red flowers with yellow centers. It is the best cultivar I have seen. A Galaxy hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Walther Funcke’ has gray foliage and deep red flowers on 2' tall stems. Quite handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Weser River Sandstone’ has deep rose-pink flowers on 2-3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Beauty’ produces creamy white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("‘Moonshine’")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Moonshine Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lemon Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid origin")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("This hybrid, between "), _c('em', [_vm._v("A. clypeolata")]), _vm._v(" and "), _c('em', [_vm._v("A.")]), _vm._v(" "), _c('em', [_vm._v("aegyptiaca")]), _vm._v(" var. "), _c('em', [_vm._v("taygetea")]), _vm._v(" (formerly "), _c('em', [_vm._v("A")]), _vm._v(". ‘Taygetea’), was introduced in the 1950s by Alan Bloom of Bressingham Gardens in ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Diss, England. In the garden, ‘Moonshine’ is similar to ‘Coronation Gold’ except in size and shade of flower color. The inflorescences are flat-topped, dense, deep lemon-yellow and 2-3\" in diameter while the gray-green foliage is filigreed. It is one of the most popular yarrows in American landscapes and is often recommended because of habit and bright flower color. While a handsome plant, ‘Moonshine’ tends to become twiggy, lose some of its foliage and die out after 2-3 years in the garden.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea")]), _vm._v(" ‘Moonshine‘")])]), _c('p', {
    staticClass: "indentp"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The flowers appear in early June (late June in New England) and continue until September. However, it is much more perennial in the North than in the South. In the Southeast where summer days are frequently punctuated by late afternoon rains and high humidity, ‘Moonshine’ tends to “melt out”. This is not surprising considering that one of its parents, "), _c('em', [_vm._v("A. aegyptiaca")]), _vm._v(" var. "), _c('em', [_vm._v("taygetea")]), _vm._v(", is also susceptible to many foliar diseases. ‘Moonshine’ does best during summers with little rainfall, otherwise don’t waste your money. The Southeast is particularly taxing on plants susceptible to root fungi, however, regardless of the region of the country in which it is grown, excellent drainage is necessary to ensure more than 2 years garden longevity. Spraying for diseases such as "), _c('em', [_vm._v("Botrytis")]), _vm._v(" and root rot organisms such as "), _c('em', [_vm._v("Pythium")]), _vm._v(" is helpful and should be practiced in July and August. Regardless of the drawbacks, this was one of the ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("finest hybrid yarrows developed in many years and, if sited properly and grown well, can still be a popular plant for commercial landscapers and gardeners.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division any time during the growing season.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ptarmica")])]), _vm._v(" (tar' mah-ca)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sneezewort")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 2-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I can think of few other common names in the plant kingdom as ugly as sneezewort. Hearing the name for the first time certainly doesn’t endear this species to anyone. The common name is derived from the fact that “the floures make one neese exceedingly”. In Victorian England, the leaves and roots were also dried and reduced to powder and used as an inexpensive substitute for snuff.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("The species is unusual among yarrows due to the lack of dissected leaves. The sessile foliage is finely toothed and fernlike, and the shape is linear to lanceolate. The species itself is of little ornamental value but a number of good cultivars are available. ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The cut flowers are occasionally used as a substitute for baby’s breath and dry well. It is an aggressive plant and will spread considerably in good soils. Susceptible to powdery mildew in wet soils and shady conditions.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea ptarmica")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Propagate by division in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of these look the same. Some may differ in height, and perhaps garden performance as well.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Angels’ Breath’ bears many half-inch wide clean white flowers on 15-18\" tall plants. Good filler for bouquets.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Aunt Stientje’ has dark green leaves, and bears flowers with large creamy white rays. I don’t see this plant in this country at all, however it earned an Award of Garden Merit from the Royal Horticultural Society in 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ballerina’ is an excellent cultivar with clean white flowers, topping out at about 18\". Good as a dried cut flower. A dwarf form, ‘Nana Ballerina’, grows only 8\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Globe’ has small buttonlike blossoms on 12-18\" tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gypsy White’ appeared in our trials in 2005, and flowered for months on 9-12\" tall plants. An excellent introduction where a dwarf white is called for.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Pearl’ is more correctly listed as The Pearl group, consisting of a number of closely related white double-flowered taxa. In general, plants bear a profusion of double white flowers on 2' high stems but in warm summers, plants sprawl and are weedy looking. All double-flowered cultivars produce some single flowers as well. Up to 30% single flowers may be produced depending on weather and cultivar.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snowball’ is similar to The Pearl group and may be part of it. The white double-flowered plants are about 2' tall and are supposed to be a little more compact than plants in The Pearl group. I can see little difference.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Perry’s White’ is taller (up to 30\"), with flowers similar to the species but opening about a week earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tomentosa")])]), _vm._v(" (tow-men-tos' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Woolly Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The common name provides an excellent description of the deeply cut, light green foliage, which is covered with long hairs, providing a truly woolly appearance. Good drainage is essential and the rock garden is a particularly suitable location, however, plants also make good subjects for the front of the border. It is most handsome in the spring when the hairy new growth begins to clamber over rocks and invades small niches. Many sulphur-yellow flowers, similar to, but smaller than those of ‘Moonshine’, are produced in June (May in the South) and continue for 3-5 weeks.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Unfortunately, plants are intolerant of hot, humid conditions and cannot be recommended for areas south of zone 6. Although they will survive in zone 7, plants perform well only through early summer and decline by mid to late July, unlikely to be seen again. This is not a species for southern landscapes unless frequent fungicide applications are made. I used to grow it in zone 7 as an annual because I enjoyed the ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("woolly texture enough to replace it in the spring. I am too lazy to do that anymore, but I still enjoy it in other people’s gardens.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Most cultivars are usually propagated by division but the species and var. "), _c('em', [_vm._v("aurea")]), _vm._v(" may also be seed propagated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("nana")]), _vm._v(" (‘Nana’) has golden yellow flowers on 3-6\" tall stems. Sometimes sold as ‘Little Beauty’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Maynard’s Gold’ produces bright yellow flowers on 10-12\" stems. Some authorities believe var. "), _c('em', [_vm._v("aurea")]), _vm._v(" and ‘Maynard’s Gold’ to be one and the same. They are probably correct.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. ageratum")]), _vm._v(" (formerly "), _c('em', [_vm._v("A. decolorans")]), _vm._v(") ‘W.B. Childs’ bears single creamy-white flowers similar to sneezewort. If not for the difference in leaf shape, one would be challenged to tell the two apart by looking only at the flowers. The plants, however, have dissected deep green leaves whereas those of sneezewort are almost entire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Alabaster’, a hybrid from Germany, bears flat heads of pale yellow flowers on stiff 30\" tall gray-green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Anthea’ was introduced by Alan Bloom by crossing ‘Moonshine’ with "), _c('em', [_vm._v("A. clypeolata")]), _vm._v(". Plants are more erect and the foliage is soft and silver-gray while the flowers are more sulphur-yellow than those of ‘Moonshine’. In our trials at Georgia, the flower heads were about 3\" across but tended to fade to creamy yellow as they mature. At the same time, secondary flowers emerged freely. Flower heads should be deadheaded to extend flowering. A terrific introduction named after Mr. Bloom’s daughter, far better than ‘Moonshine’ in yarrow-challenged environments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. chrysocoma")]), _vm._v(", yellow yarrow, is similar to "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(" but the leaves are more hairy, appear to be coated with white fur and the golden yellow flowers are a little wider. ‘Grandiflora’ has larger flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. clavennae")]), _vm._v(" grows 2-3' tall and bears up to 25 small white flowers in the inflorescence. Plants form handsome clumps of silky gray foliage. Prefers limey soils. Hardy to about zone 5-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("jaborneggii")]), _vm._v(" is a hybrid between "), _c('em', [_vm._v("A. clavennae")]), _vm._v(" and the alpine species "), _c('em', [_vm._v("A. erborotta")]), _vm._v(" subsp. "), _c('em', [_vm._v("moschata")]), _vm._v(". Clean white flowers over deeply cut clumps of gray-green foliage occur in late spring. Plants are only about 4-6\" tall and most suitable for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("kellereri")]), _vm._v(" also bears creamy white flowers but with soft yellow centers on 6-8\" tall plants. The plant is a hybrid between "), _c('em', [_vm._v("A. clypeolata")]), _vm._v(" and "), _c('em', [_vm._v("A. ageratifolia")]), _vm._v(", which has small white daisies and silver foliage. The resulting hybrid has wonderful fernlike gray foliage that is as pretty as the flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("lewisii")]), _vm._v(", a hybrid between "), _c('em', [_vm._v("A. clavennae")]), _vm._v(" and "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(", bears woody stems and soft silver-green foliage. The leaves are not as hairy as "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(" and plants are a little taller.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘King Edward’ bears primrose yellow flowers on 4-10\" stems. This and the previous hybrid require excellent drainage and are useful only in areas of cool summer nights.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('em', [_vm._v("A. sibirica")]), _vm._v(" is highly variable and still poorly known. Its leathery pinnatifid leaves are sessile, more compact, deeper green and in many ways far more handsome than "), _c('em', [_vm._v("A. millefolium")]), _vm._v(" or "), _c('em', [_vm._v("A. ptarmica")]), _vm._v(". The ray flowers are yellow and the discs are brown. ‘Stephanie Cohen’ was named for our brilliant plant lady in Pennsylvania and bears soft pink flowers all summer. ‘Kiku-San’ is about 18\" tall with creamy white ray flowers and brown centers. It was an exceptional performer in the Gardens at UGA. The var. "), _c('em', [_vm._v("kamtschatica")]), _vm._v(" has pastel pink flowers but its cultivar ‘Love Parade’ is a wonderful 2' tall plant with lavender-rosy pink flowers and the same glossy green foliage. Flowers fade to an off-white as they mature.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("wilczekii")]), _vm._v(" is a low-growing white-flowered hybrid between "), _c('em', [_vm._v("A. ageratifolia")]), _vm._v(" and "), _c('em', [_vm._v("A. lingulata")]), _vm._v(". The plants form mats under conditions of good drainage and sunshine. Particularly useful for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aconitum")])]), _vm._v(" (ak-ko-ny' tum)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Monkshood")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('em', [_vm._v("Aconitum")]), _vm._v(" has a number of common names, one of which is monkshood, so called because of the enlarged sepal that resembles a hood, under which the rest of the floral parts are hidden. Roots were used as poison bait for wolves, thus accounting for another popular common name, wolfsbane. All aconitums have poisonous roots, leaves, and stems and warnings concerning their poisonous properties have been sounded since the late 1500s. In "), _c('em', [_vm._v("A New Herbal")]), _vm._v(", William Turner writes, “Let oure Londiners which of late have receyved this blewe wolfes bayne ... take hede that poyson of the rote of this herbe one daye do not more harme than the freshness of the flower hath done pleasure in seven yeres, let them not saye but they are warned.” It may even have been used to rid oneself of an unwanted husband or wife, but “it was considered rather a vulgar poison and was not employed by persons of high rank, who probably thought Socrates’ hemlock more distinguished.” The turnip-shaped tuberous roots, however, are the most toxic and should not be planted near root crops such as potatoes or horseradish in case of accidental harvesting. Roots have even been confused with those of celery while incredibly, some people ate leaves thinking they were parsley! What were they thinking? Use of aconitum alkaloids in modern medicine was largely discontinued by the late 1930s and early 1940s, although they are still available as a local analgesic in liniments and as a heart sedative.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regardless of the morbid properties, aconitums are excellent garden plants. The ornamental part of the flower consists of 5 sepals, not petals, with the uppermost one enlarged to form a “hood” or “helmet”. Petals vary in number from 2 to many, but are found inside the hood. The flowers are arranged in terminal racemes or panicles and flower in summer to early fall. Flowers of the more common species occur in various shades of blue, however, several species have sulphur-yellow flowers, while rose-colored flowers occur in "), _c('em', [_vm._v("A. pyramidale")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("All species have been undergoing serious taxonomic reshuffling, and many subspecies have been described. Their identification is difficult at best, impossible without resorting to checking floral parts with a microscope. The leaves are alternate, dark green and usually palmately divided. They superficially resemble those of "), _c('em', [_vm._v("Delphinium")]), _vm._v(" but the flowers of the two genera are distinctly different. Among other things, ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("flowers of "), _c('em', [_vm._v("Aconitum")]), _vm._v(" usually have two petals whereas those of "), _c('em', [_vm._v("Delphinium")]), _vm._v(" have four. If people were to mix up aconitum with delphinium, I can understand, but parsley!")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Aconitums should be planted in full sun but will tolerate afternoon shade, particularly when planted near the southern boundary of their range (zone 6). They also tolerate moist soils but abhor swampy conditions. Plants need cool nights to flourish, and languish in southern regions of the country. If summer night temperatures do not regularly fall below 70°F, they should not be planted. A couple of native species, "), _c('em', [_vm._v("A. uncinatum")]), _vm._v(" and "), _c('em', [_vm._v("A. reclinatum")]), _vm._v(" extend as far south as North Carolina but are always found at higher elevations. One of the few disappointments I have had in gardening in the South is the absence of the stately spires of "), _c('em', [_vm._v("Aconitum")]), _vm._v(". It did well in southern Ontario (zone 4), but try as I may, I cannot grow monkshood well in north Georgia (zone 7).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most species are at least 3' tall and look out of place in the front of the garden, however "), _c('em', [_vm._v("A.")]), _vm._v(" ‘Ivorine’, a 2-3' tall plant with ivory-colored blossoms in early summer, may be planted in the foreground. A few species, such as the Asian "), _c('em', [_vm._v("A. volubile")]), _vm._v(" and the eastern United States natives, "), _c('em', [_vm._v("A. uncinatum")]), _vm._v(" and "), _c('em', [_vm._v("A. reclinatum")]), _vm._v(" are ramblers and can be trained to run through small trees and shrubs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flowering time for most of the monkshoods is late summer and fall, however, the 6' stately dark-purple spires of "), _c('em', [_vm._v("A. henryi")]), _vm._v(" open with the summer phlox and late daylilies. "), _c('em', [_vm._v("Aconitum")]), _vm._v(" produces good cut flowers but care should be taken not to get any sap from the cut stem on open wounds, or to mistake the leaves for parsley garnish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant the tuberous roots in the fall to establish the root system before the first hard frost. Set the crowns just below the soil surface about 12-18\" apart. Do not disturb established plants as they do not transplant well. Plant in full sun in a well-drained area where you would like them to be for the next ten years for that is where they should stay. If conditions are too wet, various fungi such as "), _c('em', [_vm._v("Sclerotinia")]), _vm._v(" will cause root rot and serious decline of the population. The upright forms make excellent cut flowers, persisting in the vase for 4-7 days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed propagation is particularly difficult because the seed develops a deep dormancy upon ripening. Sow seed as soon as collected from the plant. Germination of old seed will occur, but very slowly (12-18 months is not uncommon). Seed-grown plants take 2-3 years to flower. To propagate vegetatively, the brittle tuberous roots can be separated in late fall or very early spring.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Aconitum Species")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Leaves divided all the way to base")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("cammarum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Various")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. carmichaelii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. lamarckii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. napellus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. reclinatum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cream")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("cammarum")])]), _vm._v(" (kam-mar' um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Bicolor Monkshood")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plant is often described as a species, but as far as I can tell it is a hybrid between "), _c('em', [_vm._v("A. variegatum")]), _vm._v(" and "), _c('em', [_vm._v("A. napellus")]), _vm._v(". The growth habit is quite variable depending on the dominant parent in a particular cultivar. The inflorescences are often branched and the “helmet” may be strongly arched forward. The leaves are 2-4\" long and divided into 5-7 segments. Seldom is the hybrid found, however, a few cultivars call this plant home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bicolor’ is 3-4' tall and has blue and white flowers loosely borne on wide branching panicles derived from "), _c('em', [_vm._v("A. variegatum")]), _vm._v(". This is sometimes sold incorrectly as "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("bicolor")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-carmichaelii")])]), _vm._v(" (kar-my-keel' lee-eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Azure Monkshood")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-6'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dark Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Central China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are thicker and more leathery than those of "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("cammarum")]), _vm._v(" and not as deeply dissected. The leaves are cut about two-thirds of the way to the midrib into 3-5 lobes. It is a sturdy plant that seldom needs staking and has dark blue flowers in late summer and early fall. Afternoon shade and sufficient moisture are necessary for plants to be at their best. When planting, large amounts of organic matter should be incorporated in the planting hole. This species flowers about 2 weeks later than "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("cammarum")]), _vm._v(" and is often referred to as the fall-flowering aconitum. The flowers are deep purple within and lighten to pale mauve on the outside. A planting incorporating Japanese anemones, late monkshoods, and autumn sedums such as ‘Autumn Joy’ is truly breathtaking. Some taxonomic shenanigans are going on, and some want to separate the species "), _c('em', [_vm._v("Aconitum fischeri")]), _vm._v(" from "), _c('em', [_vm._v("A. carmichaelii")]), _vm._v(", others, like myself, see little enough difference, and lump them. For the gardener, either will do well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Arendsii’ (syn. "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("arendsii")]), _vm._v(") is a hybrid between "), _c('em', [_vm._v("A. carmichaelii")]), _vm._v(" and its var. "), _c('em', [_vm._v("wilsonii")]), _vm._v(". Raised by Georg Arends of Arend’s Nursery in Ronsdorf, Germany, this definitely deserves to be used more. Plants bear large helmets of intense blue in September and October and stand 3-4' tall. The stems are sturdy enough to be self-supporting and, everything considered, is the best late-flowering aconitum in cultivation.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Barker’s Variety’ has deep blue flowers and comes true from seed.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("‘Kelmscott Variety’ has lavender blue flowers and is similar in habit to ‘Bakers Variety’. Both cultivars were raised by Mr. Barker of Kelmscott, near Ipswich, eng-land. They grow to a height of 6' under ideal conditions. var. "), _c('em', [_vm._v("wilsonii")]), _vm._v(" (‘Wilsonii’) is up to 6' tall with 12\" long loose panicles of deep blue flowers.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-lycoctonum")])]), _vm._v(" (lye-cock' tone-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow Wolfsbane, Badger’s Bane")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-6")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is nice to see some yellow flowers in a genus so seemingly populated with blues and purples. The light green leaves consist of 5-7 deeply divided lobes arranged up the 4' long stalk. The plants are laden with terminal racemes of small yellow flowers in late summer and early fall and stems may topple on other plants when in flower. This is not altogether bad as a little touch of aconitum can do wonders to some old tired plants in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two subspecies are occasionally sold but quite mixed up. subsp. "), _c('em', [_vm._v("neapolitanum")]), _vm._v(" ("), _c('em', [_vm._v("A. lamacrkii")]), _vm._v(") has a many-branched inflorescence and flowers quite heavily while subsp. "), _c('em', [_vm._v("vulparia")]), _vm._v(" ("), _c('em', [_vm._v("A. vulparia")]), _vm._v(") has a few terminal inflorescences with pale yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Russian Yellow’ has large, deeply cut leaves and pale yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-napellus")])]), _vm._v(" (na-pel' lus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Monkshood")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dark Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-6")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the most common of the monkshoods and easiest to locate in catalogs and garden centers. The leaves are divided to the base and divided again into linear or lancelike segments. The flowers are in spikelike terminal racemes. Unfortunately, the species is exceptionally variable, and is divided into numerous subspecies differing in height, flower color and structure of the inflorescence. It is tough enough to determine which aconitum you are growing, without the confusion apparent in a single species.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The popularity of "), _c('em', [_vm._v("A. napellus")]), _vm._v(" has declined with the introduction of newer garden cultivars but it is still an outstanding plant. Although plants are toxic, the ground-up leaves have been used as an external treatment for rheumatism and neuralgia, and internally to relieve fevers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Album’ ("), _c('em', [_vm._v("A. napellus")]), _vm._v(" subsp. "), _c('em', [_vm._v("vulgare")]), _vm._v(" ‘Albidum’) bears white flowers on erect 3-4' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Valley’ grows about 3' tall with deep to medium blue flowers. Plants are upright and strong. The foliage is dull green.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow White’ is equally handsome, and may be nothing more than ‘Album’ with a better name. Regardless, it is worth the effort to try some of these non-blue forms.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-reclinatum")])]), _vm._v(" (re-clin-a' tum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Trailing Wolfsbane")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Cream")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeast United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Unlike most others in the genus, this native is a vining, sprawling plant, which needs to be grown through other plants in the garden. The species is native from Virginia to West Virginia and south to north Georgia. Plants look great in the spring as the basal leaves emerge, but they can get a little wild as they loop their way here and there. They provide more of a curious journey than a destination, but they are fun to ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("try. All aconitums are best grown in climates with cool nights—this one is way too weedy-looking in hot, humid climates to even try it.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. henryi")]), _vm._v(" has leaves divided into 3 segments and indigo blue flowers. ‘Spark’s Variety’ is thought to be a cultivar but may be a hybrid. Regardless, it is dark blue and 4-5' tall, similar to ‘Bicolor’ in habit. Both cultivars may require staking, particularly if grown in too much shade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Hybrids")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Lagoon’ grows only 12-15\" tall with medium blue flowers and dark green leaves. Plants flower in mid to late summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Sceptre’ has erect 2-3' stems terminating in dense inflorescences of blue and white flowers. Flowering stems are not as branched as in ‘Bicolor’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bressingham Spire’ is 2 1/2-3' tall with violet blue flowers in dense upright panicles suggesting the influence of "), _c('em', [_vm._v("A. napellus")]), _vm._v(". Lateral flowers develop after the terminal flower begins to open. This cultivar is particularly valuable because staking is not required. The latter two cultivars resulted from seedlings from crosses by Alan Bloom between ‘Newry Blue’ and the bicolored "), _c('em', [_vm._v("A. cammarum")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Carneum’ is a pink to salmon-flowered form that is sometimes offered as ‘Roseum’ or ‘Rubellum’. The pink color adds another dimension to "), _c('em', [_vm._v("Aconitum")]), _vm._v(" but plants must be grown where night temperatures are consistently cool or flowers fade to a dingy washed-out white. Spectacular where happy.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eleonara’ bears terminal racemes of handsome white flowers with blue edges over rigid stems that grow to 3' tall. The glossy green leaves have 5-7 deeply incised toothed lobes.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("‘Ivorine’ was raised in the early 1950s by Alan Bloom and is an outstanding compact, early-flowering plant. The creamy white flowers are held in short spikes. Becoming more popular as plants become more available. If you can grow "), _c('em', [_vm._v("Aconitum")]), _vm._v(", try this one.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Newry Blue’, raised by Mr. Tom Smith of Daisy Hill Nursery in Newry, Northern Ireland, is 4-5' tall with navy blue flowers and has the same upright flowering habit as ‘Bressingham Spire’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Sensation’ bears many light pink flowers with a deeper colored margin. Plants are 2-3' tall and about 2' wide.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Stainless Steel’ is a relatively new introduction, with many flowering stems of metallic pale lilac flowers with a metallic silver sheen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Acorus")])]), _vm._v(" (a-core- us)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Sweet Flag")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Araceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Looking at the foliage of this fine genus, one would be sure that these are ornamental grasses. The flowers are rather inconspicuous and plants are grown mainly for their handsome grasslike foliage. They are naturalized in shallow water by lakes and slow rivers, therefore excellent for wet areas or bog gardens. While wet conditions are important, they may be grown in well-irrigated garden conditions. These terrific plants have earned a spot in the American garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Acorus Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Foliage highly fragrant")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. calamus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. gramineus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-1 1/2")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-calamus")])]), _vm._v(" (kal' a-mus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sweet Flag")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Asia, Southeast United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The foliage, which resembles a large flag iris, releases a pleasing cinnamon scent when crushed or broken. One of the first air fresheners, sweet flag leaves were strewn around rooms to counteract the smells of cooking or garbage. Calamus root was also used at one time in the manufacture of cosmetics. The aromatic chemicals, known as oil of calamus, are extracted from the foliage and roots, and may still be purchased today. Leaves also contain a chemical, asarone, which was once used as a flavoring ingredient.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves may sometimes reach 4', but around 2 1/2 feet is more common. The flowers are minute and greenish, on a 2-3\" long spadix without the ornamental spathe seen in most members of this family. Full sun and moist soils are preferred but partial shade is also tolerated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division when plants become crowded.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Argentostriatus’ is the proper name of the plant that is often sold as ‘Variegatus’. It is by far the most popular cultivated form, bearing long narrow leaves with clean lines of creamy white bands. I grow mine in shallow water in my pond.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-gramineus")])]), _vm._v(" (gram-in' ee-us)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dwarf Sweet Flag")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-15\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The differences between this species and the previous include a smaller stature, shorter, more pendulous sedgelike leaves and a greater choice of cultivars. The foliage is not as sweet as "), _c('em', [_vm._v("A. calamus")]), _vm._v(" but the greater choices of leaf color and stature provide worthy plants for the garden. Plants perform well in partial shade to full sun where they form a wide clump, often used as a slow-growing ground cover. I give an ice cream cone to the first student who can find the flowers. They consist of a small narrow spadix enveloped in a 2-3\" long creamy white spathe, well hidden within the leaves. However, after sufficient brushing and combing of the foliage, serious calories are dispensed. The species is not always available but many of the selections are terrific.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Edge’ bears 1' tall fans of colorful gold and green variegated foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Pheasant’ is similar to but taller than ‘Ogon’. Plants bear narrow, straplike leaves, which are chartreuse when young then mature to a handsome gold.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("‘Licorice’ is from the U.S. National Arboretum and must be abused to be enjoyed. Rub your fingers against the foliage or dig a few roots and the anise scent will be quite obvious. From the outside, it is similar to the species.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Masamune’ is a dwarf form (6-8\") with creamy variegation on the narrow leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Minimus’ is only 3\" tall with dark green leaves. ‘Minimus Aureus’ is a golden form of this dwarf cultivar that is a sock-knocker-offer, particularly when combined with some of the purple heucheras. Because of its small size and brilliant color, it has become a favorite with the garden train enthusiasts. I have also seeen this listed as ‘Miniature Gold’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Oborozuki’ is a robust grower with green leaves and yellow variegation. Plants grow 10-12\" tall. A little more green than ‘Ogon’, but similar in the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ogon’ has been and continues to be the most popular cultivar for good reason. The fanlike leaves appear golden yellow because of the chartreuse and cream variegations on the evergreen foliage. Plants are 8-10\" tall. I have grown this one for years in my garden; it keeps trying to grow into the path, but my trusty Lawn-Boy keeps it in bounds.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pusillus Nanus’ bears fan-shaped fronds of 2-4\" tall dark green foliage. Hard to find much difference between this and ‘Minimus’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tanimanoyuki’ can’t be pronounced but can be enjoyed. The green leaves are brushed with yellow along the blades.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegatus’ grows about 12\" tall and bears narrow leaves nicely striped with cream.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Yodo-no-yuki’ has variegated pale green leaves with narrow silver stripes. Growing about 12\" tall, the foliage is slightly more muted than ‘Ogon’.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Actaea")])]), _vm._v(" (ak-tee'-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Baneberry, Bugbane")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Since the last edition of this book (1997), the genus has become a Fat Albert, gobbling up "), _c('em', [_vm._v("Cimicifuga")]), _vm._v(" while no one was paying attention. As a scientist, I understand the credo of “let’s get it right”, therefore evaluation and revaluation of scientific issues are normal and important aspects of any field of study. In the field of taxonomy, new techniques have allowed much more in-depth studies, occasionally resulting in lumping and splitting of families and genera, and wholesale changes to species. For the most part, these changes have been of little interest to gardeners, most gardeners did not deal with botanical names anyway. However retailers and producers do, and were caught between what is correct, and what their clients understood. And most changes in the last thirty years were simple enough. However, some blockbusters have recently come our way and we have been forced to come face to face with the science, and accept or ignore the changes. Often, we ignore them. We did not go gently into that good night with the wholesale changes made to "), _c('em', [_vm._v("Chrysanthemum")]), _vm._v("; we hated them and dug our heels in hoping they would go away. Similar changes in the genus "), _c('em', [_vm._v("Aster")]), _vm._v(" are upon us, to say nothing of movement between families, an almost daily taxonomic occurrence.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I mention all this now because the genus "), _c('em', [_vm._v("Cimicifuga")]), _vm._v(" has all but disappeared. Like every other change, it has been a slow journey from accepted publication in a scientific journal to finding its way into the gardening and industry literature—and ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("even longer before it is accepted by any of us. The official dismissal of "), _c('em', [_vm._v("Cimicifuga")]), _vm._v(" occurred in 1998 with a paper from James Compton, and to my amazement, many people have already accepted it, a record for sure. Personally, I dislike it, and have trouble understanding the rationale, however it looks like the changes are here to stay, so let’s get with the program. Here we go, welcome to the wide, wide world of "), _c('em', [_vm._v("Actaea")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the original genus, three common species are grown for their compound leaves and colorful berries. Unfortunately, the berries and roots are poisonous, which accounts for the common name, baneberry. It is reported that eating only 6 berries can produce severe symptoms. For this reason plants should not be grown where children and pets play. The other common name, bugbane, is a translation from "), _c('em', [_vm._v("cimex")]), _vm._v(", a bug, and "), _c('em', [_vm._v("fugo")]), _vm._v(", to drive away. When Linnaeus named this plant in 1750, he knew that "), _c('em', [_vm._v("Cimicifuga foetida")]), _vm._v(", a species from Asia, was dried and ground into powder and used to stuff pillows, mattresses and cushions as a protection against biting insects. For retailers, however, this name does little to attract customers, perhaps we could call it “white spire plant” or something a little less itchy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All plants are woodland species and do well in moist, shady location and rich, acid soil similar to its native habitat at the edge of woods where leaf mold is plentiful. In early spring, the white flowers appear in terminal racemes, and give way to 1/4\" long oval berries in late summer and early fall. The fruit is equally ornamental as the flowers, but they are eaten by varmints with tougher constitutions than ours.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the inclusion of the new species, the genus also includes slender, tall plants with much longer long wands of white flowers. The species of garden value have white flowers with minute petals and the stamens provide much of the beauty. All species have ternately compound leaves, a fancy term meaning that the leaves are divided into three segments, three times. All plants in the genus prefer moist, humus-rich soil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They often require 3-4 years before decent flowering occurs and patience is necessary. Unfortunately for gardeners dealing with warm summer nights and high humidity, plants are often disappointing. Unless they receive just the right micro-environment in such a setting, they tend to be stunted and do not flower particularly well. Perhaps if plants were never seen growing in their prime in other gardens, people wouldn’t be so picky. They continue to flower in the Armitage garden, but I wouldn’t put them in a landscape I was designing for someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed should be sown when fresh, as old seed is much more difficult to germinate uniformly. In sowing this and other genera of the Ranunculaceae, place the moist seed tray at about 70°F for 3 weeks, then transfer to freezing conditions (28-30°F) for about 5 weeks. After the cold treatment, remove the tray from the freezer and place at 40-50°F until germination occurs. All this is more easily accomplished by sowing in the fall, allowing snow cover or mulch to maintain slightly freezing temperatures followed by cool spring temperatures to satisfy the requirements. A more rapid means of propagation is by root division in the spring.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Actaea Species")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fruit ornamental")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. matsumurae")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. pachypoda")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yes, white")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. podocarpa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. racemosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. rubra")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yes, red")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. spicata")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yes, black")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("- matsumurae")])]), _vm._v(" (mat-sue' mur-aye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Kamchatka Bugbane")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Russia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Cimicifuga simplex")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Kamchatka bugbane does not have the majesty of some other species, it has gained a significant following. The flower stalks are more arching than those of "), _c('em', [_vm._v("A. racemosa")]), _vm._v(" and the secondary stalks are often taller than the terminal raceme. Flowers of this species are generally the last of the bugbanes to open, often taking a minor frost or two, a bonus for gardeners looking for late season color. Plants are more tolerant of basic soils than other species. They are also the best species for the south.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate similar to "), _c('em', [_vm._v("A. podocarpa")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Atropurpurea Group is probably the best way to classify these dark foliage forms. They look alike at first glance and only subtle differences in foliage color can be found. The group includes ‘Bernard Mitchell’, ‘Black Negligee’, ‘Braunlaub’, ‘Brunette’, ‘Hillside Black Beauty’, and ‘James Compton’. They all have bronze to deep purple foliage, stand 3-4' tall and can all be spectacular. I am perhaps a little biased towards the latter two selections, but I have never seen them all lined up side by side for a critical comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Pearl’ has large (over 2' long), dense white flower spikes. Flowers open in late October in my garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elstead Variety’ has finely cut dark green foliage, over which purplish brown flower buds open to pure white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pritchard’s Giant’ is an immense cultivar, easily growing 4-5' tall. All cultivars are vast improvements on the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-pachypoda")])]), _vm._v(" (pak-ee' poe-da)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White Baneberry, Doll’s Eye")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7a")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("(syn. "), _c('em', [_vm._v("A. alba")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The species keeps changing from "), _c('em', [_vm._v("A. pachypoda")]), _vm._v(" to "), _c('em', [_vm._v("A. alba")]), _vm._v(" and back again, but if you ask for doll’s eyes, it won’t matter at all. The compound leaves, similar to those ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("of "), _c('em', [_vm._v("Astilbe")]), _vm._v(", are handsome even without the flowers and fruit. The fringed flowers are borne in 2-4\" long terminal racemes on green flower stalks well above the foliage. The flower stalks (pedicels) become thicker ("), _c('em', [_vm._v("pachypoda")]), _vm._v(" means “thick foot”, referring to the pedicel) and turn a pinkish red as the white berries develop. Although the fruit of "), _c('em', [_vm._v("A. pachypoda")]), _vm._v(" and "), _c('em', [_vm._v("A. rubra")]), _vm._v(" usually are different colors, there is a red-fruited form of "), _c('em', [_vm._v("A. pachypoda")]), _vm._v(" (forma "), _c('em', [_vm._v("rubrocarpa")]), _vm._v("), making the shape of the pedicel the best means of distinguishing the two species. This is a handsome plant for the shady area of a woodland setting or border. The deep green leaves appear fresh well into the late summer and the berries provide interest into late fall. Abundant moisture is required in areas of hot summers; plants perform better in areas of cool nights. I coaxed mine along in my garden in north Georgia for a few years, but it kicked its legs up and finally succumbed.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea pachypoda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("‘Misty Blue’ is similar to the species but the showy leaves are blue-green, similar to the color of the foliage of fringed bleeding heart. The plant was named in 1998 by Richard Lighty of Mt. Cuba Center in Greenville, Delaware.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("podocarpa")])]), _vm._v(" (po-do-car' pa)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("American Bugbane")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-6'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Cimicifuga americana")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although not as common in gardens as the other species, it is easier to cultivate. Native from New York to Pennsylvania and as far south as the mountains of Georgia, plants are adaptable to a wide range of conditions. The 1-3\" long, rounded leaflets have 3-5 toothed lobes and heart-shaped bases. The flower stalks are sometimes branched near their base providing additional flowers as the season progresses. If you look closely at the flowers, the bracts at the base of the flower stalks (pedicels) are evident, a distinguishing characteristic of this species.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Propagation by seed is difficult and best results are obtained with fresh seed. Even then, germination is erratic and seedlings emerge over a long time. After collecting the seed, place in sand in the cold (35-40°F) for 6-8 weeks. Sow seed in a 1:1 mix of ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("peat: vermiculite and place in a warm (70-75°F), humid area. Plants can be divided but this should not be done for at least three years after planting. They have a deep root system and do not divide well.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea podocarpa")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0030-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea racemosa")])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-racemosa")])]), _vm._v(" (ray-ce-mo' sa)")])]), _c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Snakeroot, Cohosh")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("6-8'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Cimicifuga racemosa")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("This is the aristocrat of the genus whose tall white spires provide an unforgettable sight in the late summer garden. It is also the easiest to locate at nurseries and from mail order catalogs. The leaves are deeply cut and the 1-3\" long leaflets are ovate and irregularly toothed. The long racemes of creamy white flowers reach 2' in length, and are often branched near the base of the terminal inflorescence. They may look like rockets on their way to the stars, or bent and twisted in raucous contortions. To the herbalist Patricia Kyritsi Howell, they are reminiscent of a symphony, with gentle music and loud drumrolls. Pat also tells us that these plants are excellent for the treatment of anxiety, or as she calls it “the ax-murderer syndrome.” Flowers open in midsummer in zone 7 but not until late summer or early fall in zones 3 and 4. The 1-2 pistils of the flowers are sessile, that is, they have no pistil stem. This lack of stem is not particularly easy to notice, but it is one of the characteristics that make this species unique. The flowers persist for about four weeks and the spent flower spires ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("continue to be decorative for many more weeks. I can’t think of a more beautiful planting than at Naumkeag Garden, designed by Fletcher Steele, in the Berkshires of western Massachusetts. Plants have naturalized in the woodland setting and are absolutely stunning in mid July.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0031-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea racemosa")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Fewer flower stalks are produced on this species than others but its graceful yet wiry form has made it popular in American gardens. They look terrific with many cultivars of "), _c('em', [_vm._v("Phlox paniculata")]), _vm._v(". Plants need a constant supply of moisture or leaf margins turn brown and plants become stunted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate similar to "), _c('em', [_vm._v("A. podocarpa")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("cordifolia")]), _vm._v(", ("), _c('em', [_vm._v("Actaea cordifolia")]), _vm._v(") grows 4-5' tall. Leaves consist of 4-10\" long leaflets, the base of the terminal leaflet is heart shaped. Flowers are similar to those of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-rubra")])]), _vm._v(" (rew' bra)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Red Baneberry")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7a")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The flowers appear about a week earlier and are larger and not as fringed as those of the previous species. The 1/4\" long red berries are borne on slender green pedicels, which turn red as they mature. The berries are particularly poisonous and roots are violent purgatives, irritants, and emetics. The leaves are usually more hairy than those of "), _c('em', [_vm._v("A. pachypoda")]), _vm._v(" but except for the color of fruit and shape of pedicels, few differences exist. Plants require the same growing conditions as "), _c('em', [_vm._v("A. alba.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Filkins’ Selection was selected by John Filkins of New York. Plants are similar to the species, but are said to be more vigorous, and bear reliably heavy fruit each year.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Neglecta’ (forma "), _c('em', [_vm._v("neglecta")]), _vm._v(") is a white-berried form with slender stalks. Plants are also a little taller.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Actaea japonica")]), _vm._v(" now includes what was once "), _c('em', [_vm._v("Cimicifuga acerina")]), _vm._v(" as well as "), _c('em', [_vm._v("C. japonica")]), _vm._v(". Plants have dark green maple-like leaves with long pointed lobes and purple stems. An outstanding species.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Actaea dahurica")]), _vm._v(" "), _c('em', [_vm._v("(Cimicifuga dahurica)")]), _vm._v(" is native to China and Japan and is hardy in zone 5 to zone 7. All leaflets are cordate (heart-shaped). Plants grow 5-6' tall and bear creamy white flowers in simple or compound racemes. Flowers, which occur in midsummer, have a subtle fragrance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. spicata")]), _vm._v(", also known as "), _c('em', [_vm._v("A. nigra")]), _vm._v(", black baneberry, is similar to "), _c('em', [_vm._v("A. rubra")]), _vm._v(" but has jet black berries (also very poisonous) carried on short black slender pedicels.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Adenophora")])]), _vm._v(" (a-den-off' or-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Ladybells, Gland Bellflower")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Campanulaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("The ladybells are often confused with members of "), _c('em', [_vm._v("Campanula")]), _vm._v(" but are unique in having a thick disc-like structure (the gland) at the base of the style of the flower. ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("If you really don’t relish the thought of tearing apart flowers to find such mundane organs, it is helpful to know that "), _c('em', [_vm._v("Adenophora")]), _vm._v(" has numerous branched, slender stems and nodding bell-shaped lilac blue flowers. The leaves are alternate, and sessile or have very short petioles. Plants prefer a rich, well-drained soil in full sun or partial shade. In Montreal, I regarded "), _c('em', [_vm._v("Adenophora")]), _vm._v(" as an innocuous weedy member of gardens. Although plants are better behaved in Georgia, I still have trouble getting excited about it. More tolerant of heat than many of the campanulas, it may be included in the southern garden where other members of the Campanulaceae must be excluded. There are about 50 species and most gardeners know not a one of them. By far the most available members are "), _c('em', [_vm._v("A. confusa")]), _vm._v(" and "), _c('em', [_vm._v("A. liliifolia")]), _vm._v(" (often incorrectly listed as "), _c('em', [_vm._v("A. lilifolia")]), _vm._v("), but occasionally species such as "), _c('em', [_vm._v("A. pereskiifolia")]), _vm._v(" and "), _c('em', [_vm._v("A. bulleyana")]), _vm._v(" are also offered.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Adenophora Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Leaf arrangement")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. bulleyana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("30-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Alternate")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue, lilac")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. confusa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-30")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Alternate")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue, lilac")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. liliifolia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Alternate")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue, lilac")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. pereskiifolia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-30")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Whorled")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue, purple")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-confusa")])]), _vm._v(" (con-fuse' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Ladybells")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-2 1/2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This 2-2 1/2' tall species bears 3/4\" long, nodding bell-shaped, deep blue flowers in late spring. The leaves are ovate, bluntly dentate and are often sessile with leaf bases 2-3\" wide and tapered. The flowers have entire petals and open in late May to early June and continue for about 3-4 weeks. Seed is fine and should be mixed with sand or talcum powder to insure even distribution. Press seed in gently, do not cover. Keep seed tray at 70-75°F soil temperature and moist at all times. Germination takes 2-3 weeks. The roots are deep and fleshy and therefore difficult to divide or move without significant damage.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-liliifolia")])]), _vm._v(" (lily-foe' lee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilyleaf Ladybells")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1 1/2-2'/1 1/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pale Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species resembles "), _c('em', [_vm._v("A. confusa")]), _vm._v(" but is not as tall and the flowers are paler blue or creamy white. The style of the flowers is obviously exserted (projects from the petals) whereas the style of the former is only slightly so. The petals are finely serrated and the leaves are linear to lanceolate and approximately 1\" wide. This species tolerates heat better than "), _c('em', [_vm._v("A. confusa")]), _vm._v(" and is also a good plant for southern gardeners, and even better, it is the most fragrant of the ladybells.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Amethyst Chimes’ was introduced by Joy Creek Nursery and grows 3-4' tall and bears smoky lilac flowers. I believe this is the same as ‘Amethyst’.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0034-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Adenophora confusa")])])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "indentp"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('em', [_vm._v("A. aurita")]), _vm._v(" has branching stalks of blue bell-shaped flowers with strong basal leaves. Plants grow about 2' tall.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. bulleyana")]), _vm._v(" is native to western China and differs from the above species by having glossy green, ovate leaves with single serrations. The leaves are wider than the above species, all but the uppermost being about an inch wide. The pale blue flowers are often borne in threes. Handsome but uncommon. Hardy to zone 3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pereskiifolia")]), _vm._v(" bears purple bell flowers on 2-2 1/2' tall stems. The whorled leaves are pointed and slightly hairy. Excellent plants for heat and humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. potaninii")]), _vm._v(" is native to China and hardy to USDA zone 3. The stems are upright but not particularly strong, but the flowers, usually violet to blue, are pendulous. A white form, ‘Alba’, is occasionally offered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. stricta")]), _vm._v(" is taking a while to find its way to America, but it is a most handsome plant. Seeds of "), _c('em', [_vm._v("A. stricta")]), _vm._v(" var. "), _c('em', [_vm._v("sessilifolia")]), _vm._v(" were brought to England by Roy Lancaster of Hampshire, England from northwest Sichuan, China. Nodding blue bell-shaped flowers are produced on a branching raceme over kidney-shaped basal leaves. The lower leaves are stalked while the upper ones are sessile. It was originally identified as "), _c('em', [_vm._v("A. aurita")]), _vm._v(" and plants may appear in catalogs that way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. tashiroi")]), _vm._v(" is occasionally offered. Native to Japan, plants stand about 15\" tall and bear whorls of nodding blue flowers in summer.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('em', [_vm._v("A. triphylla")]), _vm._v(" is a charming 12-20\" tall plant that flowers in late summer and fall. Long exserted styles protrude from the late summer blue to violet flowers. The leaves are whorled, usually four per whorl. Native to China, hardy in zone 4-7.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Adiantum")])]), _vm._v(" (add-ee' an-tum)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Maidenhair Fern")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Pteridaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The maidenhairs provide some of the most handsome ferns in the garden. The stems are dark purple to black and the blades are arranged in fanlike segments. Of the 200 or so species, two or three are easily found by gardeners, but others are available with a little searching. Many maidenhairs are not sufficiently cold hardy for much of the country and if seen at all, are seen as houseplants. However, a number of species are quite cold tolerant and may be used as far north as zone 2, if spores or plants are available. The Aleutian maidenhair, "), _c('em', [_vm._v("A. aleuticum")]), _vm._v(", and the northern maidenhair, "), _c('em', [_vm._v("A. pedatum")]), _vm._v(", are the most cold hardy while Argentine maidenhair, "), _c('em', [_vm._v("A. lorentzii")]), _vm._v(", delta maidenhair, "), _c('em', [_vm._v("A. raddianum")]), _vm._v(", and southern maidenhair, "), _c('em', [_vm._v("A. capillus-veneris")]), _vm._v(", are most at home south of zone 7. Trailing or walking maidenhair, "), _c('em', [_vm._v("A. caudatum")]), _vm._v(", is native to the tropics but its long pendulous fronds and attractively lobed segments make a handsome summer fern regardless of winter temperatures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The maidenhairs do not perform as well in deep shade as many other species. An area with bright filtered light and good air circulation is made for maidenhairs. Well-drained alkaline soils are best and pH may be raised if necessary with the addition of marble chips or dolomitic lime. Sand and peat moss at a pH of about 7 to 8.5 is satisfactory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are relatively easy to produce from spores.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Adiantum Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Foliage arranged in horseshoe shape on stem")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Hardy to at least zone 7")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. aleuticum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. capillus-veneris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. pedatum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-20")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. raddianum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-capillus-veneris")])]), _vm._v(" (ca-pill' us ven-er' is)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Maidenhair")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-18\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Light Green Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Tropics")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-10")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Southern maidenhair fern is widely distributed from semi-tropical to tropical areas and often grown as a greenhouse plant. My daughter Laura keeps surprising me, she always has flowers in her home, but she also uses 4\" pots of southern maidenhair in decorative containers in her den. Bright girl, that Laura.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although plants are difficult to perennialize outdoors in cold temperate areas due to lack of cold tolerance and susceptibility to disease, they are showstoppers where they are happy. A great deal of variability occurs, particularly in plant performance. Plants of southern maidenhair exuberantly grow on the rock walls at Birmingham Botanical Gardens; the bright light and sheltered location made these plants glisten. The petioles are dark brown to black and the lacy, delicate foliage is light green, particularly when young. Steve Bender at "), _c('em', [_vm._v("Southern Living")]), _vm._v(" recommends southern maidenhair combined with white caladiums and nippon lily ("), _c('em', [_vm._v("Rhodea japonica")]), _vm._v(") as an outstanding combination but they combine nicely with most plants if they are grown well. Bright light is essential for good growth and if overgrown with other plants, they tend to develop dark spots on the fronds and decline. Good air movement and basic pH are essential.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fimbriatum’ has segments cut into deeply cut finger-like lobes.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Imbricatum’ is smaller with cascading fronds.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rock Springs’ was found in 2000 in the Edwards Plateau region of Texas near the town of Rock Springs, Texas by Scott Ogden and Tony Avent. Good heat tolerance is a bonus for this 2' tall cultivar.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("pedatum")])]), _vm._v(" (pe-day' tum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Northern Maidenhair Fern")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-20\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mid Green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America, East Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the most sought-after and popular ferns in temperate gardens. That it is one of our natives to boot provides added pleasure. The northern maidenhair fern provides a graceful and lacy feel in the shaded garden and quickly spreads in moist, bright areas. They thrive in cold areas but are difficult south of zone 7b. The foliage is forked and consists of 8-20 segments held in a horseshoe-like arrangement. The black shiny stems are among the most handsome in the plant kingdom. They are deciduous and slow to emerge in the spring, compared to other more vigorous ferns.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Adiantum pedatum")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Plants perform well in areas of bright filtered light and good air circulation. A basic pH is also beneficial for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of forms have been selected or developed but few are easy to find, and none is any better than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Japonicum’ has pinkish-bronze new fronds.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Miss Sharples’ produces larger leaflets and has a noticeable chartreuse color.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Montanum’ is much more compact and dense than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Adiantum aleuticum")]), _vm._v(" ("), _c('em', [_vm._v("A. pedatum")]), _vm._v(" var. "), _c('em', [_vm._v("aleuticum")]), _vm._v("), Aleutian maidenhair, is native to the western half of the country and as far north as Alaska. USDA zones 2-7. Plants are particularly cold hardy, but not recommended for areas of high heat and humidity. The branches are pendulous and weeping, and the fronds are deeply cut. Two other varieties of northern maidenhair, var. "), _c('em', [_vm._v("subpumilum")]), _vm._v(", a dwarf form, and var. "), _c('em', [_vm._v("calderi")]), _vm._v(" have recently been folded into this species.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('em', [_vm._v("Adiantum hispidulum")]), _vm._v(", rosy maidenhair, has possibilities for gardeners in the southern part of the country and as far north as zone 7. It is variable in form but generally has rough stems and dark glossy green horseshoe-shaped fronds, and is adaptable to ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("a wide range of soil conditions. The new growth is rosy pink, and in the spring well-grown plants are outstanding. Harsh winters will damage the fronds and impede the new growth and some mulching to protect from winter winds may be useful. ‘Bronze Venus’ bears new foliage that is more bronze than that of the species.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Adiantum raddianum")]), _vm._v(", delta maidenhair fern, grows 1-2' tall and is native to central and South America. Hardy only in zones 8-10. Probably the most common maiden-hair in the world, it is little seen in gardens in this country because of its lack of cold tolerance. Even in my garden in Athens (zone 7b), plants overwinter only in mild winters and struggle to multiply. They grow naturally in rocky area and bluffs and generally prefer neutral to alkaline soils. The segments are lobed and narrowly triangular and are borne on handsome black stems. It is renowned for its variability, with over 60 cultivars named by fern growers, but few are commonly available. However, fern organizations may supply spores or plantlets for fern fanciers. ‘Bridal Veil’ has drooping fronds with small teardrop segments. ‘Elegans’ bears lobed, wedge-shaped segments and is one of the easiest to raise; ‘Fritz Luthi’ has overlapping fronds, grows 1-2' tall and bears similar handsome black stems. Plants appear to be more cold hardy than most cultivars, an RHS Award of Garden Merit plant in 1997; ‘Variegatum’ produces upright fronds with segments flecked with white. Spores gathered from the strongest variegated fronds tend to produce variegated sporelings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Adiantum venustum")]), _vm._v(", Himalayan maidenhair fern, provides reasonable cold tolerance (to zone 5), but is not particularly heat tolerant. The 1-2 1/2' tall fern bears large, coarsely divided fronds and each segment is divided. Plants are becoming more available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Genus")]), _vm._v(":")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('em', [_vm._v("Adiantopsis")]), _vm._v(" appears more similar to "), _c('em', [_vm._v("Cheilanthes")]), _vm._v(" than "), _c('em', [_vm._v("Adiantum")]), _vm._v(", however a couple of forms have become available to gardeners. Neither is cold hardy much below 15°F, so think about zone 7b as its limit. So few of these are out there that I, along with all others, am guessing at best. "), _c('em', [_vm._v("A. chlorophylla")]), _vm._v(" is about 2' tall while the more common "), _c('em', [_vm._v("A. raddiata")]), _vm._v(" is shorter with fronds arranged in a starfish pattern. Both are native to Costa Rica and northern South America.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Adlumia")])]), _vm._v(" (add-loom-ee' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Allegheny Vine, Climbing Fumitory")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Fumariaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("This climbing biennial vine is represented by "), _c('em', [_vm._v("A. fungosa")]), _vm._v(", native to the northeastern United States, thus its common names, mountain fringe and Allegheny vine. The delicate, light green foliage is three times pinnate, resulting in a fernlike appearance. Plants use the petioles of new leaves to clamber and scramble over shrubs and bushes, or gardeners may train the vine along fences or arbors. The pale pink and whitish flowers are similar to those of bleeding heart ("), _c('em', [_vm._v("Dicentra")]), _vm._v(") and are formed in hanging clusters at the axils. Plants are hardy to zone 3 and may be grown as far south as zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants form a low bushy mound the first year and then, after winter, climb as fast as helium balloons released from the football stadium. Growing 10-12' tall in a few weeks, it is one of those vines that one should plant and then get out of the way. Provide some afternoon shade for best performance. The flowers are not bright or big enough to allow this to ever become a mainstream garden plant, but is fun and easy to grow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many European and some American taxonomists put "), _c('em', [_vm._v("Adlumia")]), _vm._v(" in the family Papaveraceae. However, the members of the Fumariaceae are quite distinct from those of the Papaveraceae in several respects, including floral symmetry, sap character, and stamen number and fusion. So let’s keep it with its friends "), _c('em', [_vm._v("Dicentra")]), _vm._v(" and "), _c('em', [_vm._v("Corydalis")]), _vm._v(" for a while longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate from seed; they will self-sow in areas where plants are happy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Adonis")])]), _vm._v(" (a-don' is)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Adonis")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Greek legend has it that these were favorites of Adonis, who, upon his death, was changed into this flower by the goddess Aphrodite. Adonis was regarded as the God of Plants by the Greeks, and he was believed to disappear every autumn and reappear in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 20 species occur but only "), _c('em', [_vm._v("A. amurensis")]), _vm._v(" and "), _c('em', [_vm._v("A. vernalis")]), _vm._v(" are perennial throughout most of the country. The leaves are alternate, dissected and light green. The plants are erect but normally do not exceed 18\" in height and are most effective as rock garden plants or in the front of a small border. They should be planted in masses as one or two plants do not provide enough “flower power”. Although said to perform better at a basic pH, they don’t seem particularly fussy about soil as long as it is well drained. An area that receives some afternoon shade should be chosen in the South, although full sun north of zone 5 is satisfactory. Slugs relish them and spring application of slug preventative reduces damage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Approximately 6 weeks of temperatures below 40°F are necessary for the rhizomes to break dormancy in the spring. Both species go dormant by midsummer. Plant late-emerging perennials such as "), _c('em', [_vm._v("Platycodon")]), _vm._v(" or "), _c('em', [_vm._v("Gladiolus")]), _vm._v(" or summer annuals to cover the vacant area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sow fresh seed in the spring, grow seedlings throughout the summer and transplant to the garden in the fall; plants will likely flower the next spring. Seed is notoriously difficult to germinate if not fresh, and even if collected from garden plants, seeds will need more than one year to germinate. Division is not required, however it the best means of multiplication; divide in late spring after the foliage dies down.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Adonis Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Number of leaves")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowering time")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. amurensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("9-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Few")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. vernalis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Many")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late Spring")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-amurensis")])]), _vm._v(" (am-ew-ren' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Amur Adonis")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("9-12\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan, Manchuria")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("This species flowers as early as February in southern gardens and progressively later further north. The stems are branched, each stem branch bearing triangular, 3-6\" long leaves which are cut into 3 sections to the base. Each of those sections is in turn divided into linear segments. At the base of each petiole are leafy stipules. The ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("2\" wide flowers are usually buttercup-yellow but may occasionally be white, rose, or have red stripes. Each flower has 20-50 petals, slightly longer than the sepals. The flowers generally appear just before the leaves fully emerge.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves unfurl as the flowers begin to open. If the weather remains cool when flowers open, they persist for up to 6 weeks, fewer if hot weather comes along. The golden flowers contrast well with the reticulated iris ("), _c('em', [_vm._v("I. reticulata")]), _vm._v("), crocus, and other spring-flowering bulbs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is best accomplished by division in late spring or early summer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flore-plena’ is a common double cultivar and is much showier than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fukuju Kai’ has fully open sulfur-yellow flowers and is the earliest to bloom. Other cultivars with copper, orange, pink, and white flowers have been developed by Japanese nurserymen, but have not been widely distributed.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sandanzaki’ is certainly interesting, if not calming. Plants grow about 15\" in height and bear flowers consisting of layers of yellow petals often edged in green. Unfortunately, plants are rare at best.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-vernalis")])]), _vm._v(" (ver-nah' lis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring Adonis, Pheasant’s Eye")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-15\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are more winter hardy (zone 3 with protection) than the former and flowers emerge 3-6 weeks later. It differs from the previous species by having unbranched stems and many more leaves that are sessile (no petioles) and 1-2\" long. The flowers have fewer petals than "), _c('em', [_vm._v("A. amurensis")]), _vm._v(" (10-15), which are slightly toothed, and about 2 1/2\" wide. They open as flat as a dinner plate, as if knowing their time in the sun was fleeting, to be enjoyed while they could. Plants do not go completely dormant as do those of "), _c('em', [_vm._v("A. amurensis.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is more difficult than "), _c('em', [_vm._v("A. amurensis")]), _vm._v(" and may take several years to recover from the disturbance of dividing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. apennina")]), _vm._v(" is similar to "), _c('em', [_vm._v("A. vernalis")]), _vm._v(" but has larger flowers (up to 3\") and the lower leaves are rounded and sheathlike.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aegopodium")])]), _vm._v(" (aye-go-pow' dee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Goutweed, Bishop’s Weed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Apiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("About 6 species have been described in this genus; all grow by creeping rhizomes and all can be incredibly invasive. The foliage occurs in threes and the flowers are usually white. The only species commonly seen in cultivation is "), _c('em', [_vm._v("A. podagraria")]), _vm._v(", bishop’s weed.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-podagraria")])]), _vm._v(" (pod-a-grair' ee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Bishop’s weed, Goutweed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/spreading")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Western Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 2-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Some people politely call this plant “fast growing and a good filler”. Others curse it as they wrench their backs while wrenching out this loathsome invader. No doubt it ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("can be invasive, and jump and frolic through the garden. In some cases, this no way diminishes its value, for if areas require some greenery or soil must be conserved, this plant is perfect. The leaves are produced in two groups of three (biternate) and creamy-white flowers are produced in late spring and summer. In Montreal, this plant was everywhere, in Michigan, it was not much different. However, in the southeastern United States, plants are much better behaved. It is still invasive, but takes a few more minutes to take over. Plants are tolerant of nearly all soils, and prefer partially shaded areas. They burn up in full sun, so you end up with an ugly thing all over the place. Plants multiply with creeping rhizomes and spread more quickly in cooler soil temperatures. This plant also looks good in nursery pots, therefore it is a favorite of nursery people who can sell weeds in a pot. Marketing is alive and well in North America. Plants were at one time thought to cure gout, thus one of its common names.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0041-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aegopodium podagraria")]), _vm._v(" ‘Variegata’")]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bengt’ supposedly is a non-running form from Sweden. The margins are somewhat wavy. I have not trialed this, so cannot verify this claim.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("‘Variegatum’ is more common than the species and much more ornamental. The green leaves bear creamy-white margins and plants are only a little less invasive than the species. The leaves, however, are clean and bright and if this genus must ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("be used, the variegated form is far more handsome. I yank it up from my garden and stick it the woods to brighten them up, and it still does well.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aethionema")])]), _vm._v(" (ieth-ee-o-nee' ma)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Stonecress")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Brassicaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('em', [_vm._v("Aethionema")]), _vm._v(" has never hit the mainstream of North American gardening, although plants have regional followings where rock gardens and alpine gardening are popular. Plants do poorly in warm climates, but they may be fall planted for spring enjoyment. After flowering, they generally decline. In northern areas, however, "), _c('em', [_vm._v("Aethionema")]), _vm._v(" is underused and if small stature and colorful plants are needed, stonecress may fill that need. Numerous handsome species and cultivars are available from seed and given sharp drainage, they are easily grown. All flowers consist of 4 petals and 4 sepals.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Aethionema Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Foliage color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. armenum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Light green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. grandiflorum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-20")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rose-red")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue-green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. iberideum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue-green")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-armenum")])]), _vm._v(" (ar-meen' um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkish Stonecress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink-white")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Caucasus")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This highly variable species bears narrow, linear light green to gray-green leaves and whitish pink flowers held in tightly clustered racemes. Plants dislike moist clay soils and shade, performing best on sunny, well-drained slopes or raised beds. Plants respond well to slightly alkaline soils. It is difficult to find the species but a number of handsome cultivars can usually be located in the trade.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-grandiflorum")]), _vm._v(" (gran-di-flo' rum)")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Persian Stonecress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-20\"/15\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants produce dozens of flowers in crowded upright terminal racemes, showy for many weeks. The rose-colored flowers bear petals about 4 times as long as the sepals. The blue-green leaves are needle-like and the base of the plant becomes woody. There is some variability in this species as well, and this variable group is referred to as "), _c('em', [_vm._v("A. grandiflorum")]), _vm._v(" Pulchellum group.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-iberideum")])]), _vm._v(" (i-be-ri' dee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Iberis Stonecress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern Mediterranean")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The white flowers are similar to those of "), _c('em', [_vm._v("Iberis")]), _vm._v(", thus its common name. Gray-green silvery mats of leaves carry many small, fragrant flowers less than 1\" long in a terminal raceme. Plants require excellent drainage and are best used in the rock garden or in raised beds. The diminutive height and free-flowering nature of this plant makes it highly sought after by alpine enthusiasts. In warm humid climates, it melts like an ice cream cone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. cordifolium")]), _vm._v(", heart-leaf stonecress, is similar to "), _c('em', [_vm._v("A. grandiflorum")]), _vm._v(" but is smaller in almost every way. The foliage has a blue-green hue. Plants grow to 8\" and the flowers are only about 1/5\" long. Native to Lebanon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. oppositifolium")]), _vm._v(" is only 1-2\" tall but makes handsome mats of pink-lilac flowers. Perfect for the rock garden, this woody-based plant creeps from rock to rock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. schistosum")]), _vm._v(", Persian stonecress, bears dozens upon dozens of pink flowers in early spring which as a group provide pleasant fragrance to go with the color. The evergreen leaves are tiny with an obvious blue hue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Warley Rose’ is the most popular stonecress and carries brilliant dark pink flowers densely borne over 6-8\" tall mats of gray-green foliage. The cultivar was awarded an Award of Garden Merit in 1993 by the Royal Horticultural Society. Introduced in the early 1920s by the eccentric Mrs. Wilmott of Warley House, England (see "), _c('em', [_vm._v("Eryngium giganteum")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Warley Ruber’ has dark maroon flowers. Both cultivars have been placed with various species, but now plants are thought to be natural hybrids.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Agapanthus")])]), _vm._v(" (ag-a-pan' thus)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("African Lily")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Alliaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Agapanthus is a rhizomatous plant with fleshy roots and elongated leathery leaves. Most species have strap-shaped, glossy dark green 2-3' long leaves. The flowers are carried in a rounded umbel on a thick scape and appear in late summer. In favorable climates, plants are extremely tough and durable. In areas of Britain, southern Europe and throughout New Zealand, agapanthus is common and long lasting, used as edgings, roadway dividers and hedging.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most common species are the evergreen "), _c('em', [_vm._v("A. africanus")]), _vm._v(", lily of the Nile, "), _c('em', [_vm._v("A. praecox")]), _vm._v(", and the deciduous "), _c('em', [_vm._v("A. campanulatus")]), _vm._v(". Few obvious differences occur in foliage and flower, and many selections and hybrids are far more common than the species themselves. Although "), _c('em', [_vm._v("A. praecox")]), _vm._v(" and "), _c('em', [_vm._v("A. campanulatus")]), _vm._v(" are fully hardy in areas of California and Florida, the hardiest and most available forms of "), _c('em', [_vm._v("Agapanthus")]), _vm._v(" are the hybrids; old ones like the ‘Headbourne Hybrids’ are still popular while newer cultivars are popping up in retail establishments throughout the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even in north Georgia (zone 7b), it is difficult to overwinter agapanthus, yet there are areas as far north as zone 5, where winter temperatures may routinely reach –10°F, where they overwinter. Moderation of temperatures by a lake effect, sandy well-drained soils, and snow cover help create this unusual situation. Without doubt, the majority of gardeners in this country should use agapanthus in a combination container for the deck, porch or around a garden pool, to be brought into a frost-free area during the winter. Many of the newer introductions may be hardy to zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On a taxonomic note, a good deal of discussion concerns whether the genus should be included in the Liliaceae, where it has resided or in the Alliaceae, a relatively new family. Both are accepted, I have opted to include it with the onions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allow the crowns to dry out over the rest period and begin adding water as spring approaches. The crowns should be set approximately 2\" below ground level, watered well and left undisturbed. During the growing season, plants require copious amounts of water and must not be allowed to dry out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many beautiful garden forms and hybrids have been developed and a few are gaining popularity. Some cultivars are particularly good for cut flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Albus’ (‘Albidus’) bears creamy white flowers on 2-3' tall plants. Evergreen.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alice Gloucester’ has purple flower buds and stems and bears large warm white flowers in mid to late summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Back in Black’ bears dark blue flowers, which in itself is not unusual. The “black” part comes from the flower stem which starts out dark green and ages to black.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Giant’ produces rich blue trumpets on plants that may reach 3 1/2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Globe’ is deciduous, growing about 3' tall with light blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Moon’, raised by Eric Smith of Hillier’s Nursery, has densely packed pale blue flowers on 2-2 1/2' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Triumphator’ is 2-3' tall and produces clean blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bressingham Blue’ grows about 3' tall and produces deep amethyst-blue flowers. ‘Bressingham Bounty’, with slightly broader leaves and large rich blue flowers was introduced in 1992. ‘Bressingham White’ is a vigorous plant with clean white flowers. All arose from initial seedlings raised in 1967 at Blooms of Bressingham, Diss, England.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cayles Lilac’ came from New Zealand and bears soft lilac flowers on 15-18\" tall plants with broad leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cobalt Blue’, selected by Beth Chatto of Elmstead Market, England, has cobalt blue flowers on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elaine’ was a wild hybrid found among seedlings at the Los Angeles State and County Arboretum. Plants bear large dense umbels of dark violet-blue flowers. Flower stalks are up to 4' long.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ellamae’, also selected by the Los Angeles State and County Arboretum, appears to be a cross from "), _c('em', [_vm._v("A. orientalis")]), _vm._v(" ‘Praecox’ and "), _c('em', [_vm._v("A. inapertus")]), _vm._v(". Very vigorous, plants produce dozens of violet flowers on long stalks.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gayle’s Lilac’ is a good dwarf form, standing about 1 1/2-2' tall. Plants bear many scapes of pale lilac flowers above the evergreen foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Getty White’ is a hybrid with dense heads of creamy white flowers. Vigorous and handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Glenavon’ is hard to find in the United States, but well worth the effort. Plants bear dozens of blue flowers with deep blue stripes. They are not short, growing up to 3'.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Headbourne’ hybrids arose during the 1950s and 60s from Mr. Lewis Palmer of Headbourne Worthy near Winchester, England. As a mix, they have 2-3\" long deep violet to pale blue flowers. These are among the taller of the available cultivars as well as the most cold hardy. Mr. Palmer was a leader in the breeding of agapanthus and many of his original crosses were used in the continued improvement of this genus.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Isis’ bears large inflorescences (6\" across) of deep blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kingston Blue’ is about 2' tall and produces blue-black flower buds that open to dark royal blue flowers in early summer.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("‘Liliput’ has 8-12\" long leaves, grows only 12-18\" tall and produces small pendulous dark blue flowers. Terrific for containers but slow to divide.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Loch Hope’ is one of the finest blue agapanthus in cultivation today. It is late flowering and produces flowers of the deepest violet atop 4-5' tall stems. In many of the older blue selections, the flowers fade to an unsightly reddish purple. This is not the case with this hybrid as the flowers maintain their deep color until they fall from the plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Peter Pan’ is a dwarf (about 12\" tall) cultivar with narrow foliage and handsome sky blue flowers. Excellent in containers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Profusion’ grows to 3' in height and bears many light to dark blue flowers. The variability in flower color produces a striped effect.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Baby’ has a tinge of blue all over the white flowers. Dwarf (1-2' tall), handsome and unusual.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Drops’ is a dwarf form with white flowers. Introduced from New Zealand.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snowy Owl’ is an excellent clone with creamy white flowers on 3' high stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Pixie’ produces many clean white flowers on 9-15\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("The Storm series, presently consisting of ‘Blue Storm’ and ‘Snowstorm’, has become quite popular due to plants’ heavy flowering tendencies. Developed in Australia by the Tesselaar Company.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Streamline’ arose from the Auckland Botanic Gardens and is about 18\" tall and produces blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tinkerbell’ is a short (10-12\" tall) plant with variegated foliage consisting of light green leaves with narrow clean white edges. The foliage is truly beautiful but plants seldom flower. As beautiful as the foliage is, it simply looks like a variegated liriope if the blue flowers don’t appear. Beautiful when placed in sunny, moist area.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Christmas’ is about 2' tall when not in flower but the white spires of flowers reach nearly 5' in height.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. inapertis")]), _vm._v(" bears long narrow blue-green foliage on 2-3' tall plants. I have always admired the plants in the British Isles but have not seen many in this country. The tubular flowers are dark blue, erect at first, then becoming pendulous. Sometimes the var. "), _c('em', [_vm._v("pendulus")]), _vm._v(" can be found where the flowers droop all the time. ‘Sky’ is one such cultivar with tall stems bearing pendulous, sky blue flowers in summer. A white form, ‘Alba’, also occurs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Agastache")])]), _vm._v(" (a-gah' sta-kee)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Anise Hyssop")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Lamiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("A genus consisting of approximately 20 species, mostly native to southwest United States and Mexico, often smelling of licorice or other childhood fragrances. Plants produce many spikes of flowers in lavender, red, orange and red although yellow flowers are occasionally seen ("), _c('em', [_vm._v("A. nepetoides")]), _vm._v(").")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("A good many species are not cold hardy north of zone 8, but enough are sufficiently cold tolerant to zone 7 and a few into zone 5 and 6. Many wonderful plants such as "), _c('em', [_vm._v("A. foeniculum")]), _vm._v(", "), _c('em', [_vm._v("A. cana")]), _vm._v(" and "), _c('em', [_vm._v("A. rupestris")]), _vm._v(" as well as the golden "), _c('em', [_vm._v("A. aurantiaca")]), _vm._v(" are native to the United States, and becoming more common as the popularity of ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("native plants increases. However, some species are far more useful as contributing parents for the many hybrids that have recently appeared. As more gardeners discover the xeric properties of these plants, the popularity of the hybrids will continue to increase. All plants do well in full sun and slightly alkaline well-drained soils.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Agastache Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower Color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. cana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rose-pink")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. foeniculum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("20-30")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. rugosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-30")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Violet-rose")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. rupestris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("36-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Orange-salmon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-cana")])]), _vm._v(" (can' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mosquito Plant")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink, Rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southwest United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The blue-green foliage and pink-rose tubular flowers on many, branched stems make this an excellent plant to try in the garden. Flower colors are difficult to describe with people calling them deep rose, off-pink, near scarlet and various combinations thereof. The upright racemes consist of 6-12 flowers held in each whorl. The whorls are loosely arranged on 12-18\" flowering stems. The foliage is fragrant but not nearly as much as "), _c('em', [_vm._v("A. rupestris")]), _vm._v(". Full sun and well-drained soils are essential.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate from seed at 72°F and high humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sonoran Sunset’ grows 12-15\" tall and equally wide and is covered with lavender-rose flowers most of the summer. May be cold hardy to zone 6. A Plant Select"), _c('sup', [_vm._v("®")]), _vm._v(" Winner in 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("foeniculum")])]), _vm._v(" (foe-nick' ew-lum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Anise Hyssop")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("20-36\"/30\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Growing tall, bearing many flower stems that are easily dried, anise hyssop is a favorite for cut flower producers and gardeners alike. The flowers are tightly arranged in long dense racemes. The flowers range from lavender to purple and the foliage is distinctly anise-like. They perform well in full sun but get tall and lanky if grown in too much shade. Easily propagated by seed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ (‘Alabaster’) is a common creamy white form of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Jubilee’ has been one of my favorites since we first trialed it in 2002. The anise-scented leaves are a muted yellow, although sufficiently golden to deserve the name, and they maintain their color throughout the summer. Plants produce many upright candles of lavender blue flowers in mid to late summer as well. Probably cold hardy to zone 6.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("‘Licorice Blue’ and ‘Licorice White’ bear lavender-blue and off-white flowers respectively.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snowspire’ is offered by only a handful of nurseries, but the 3' tall plants bear many white flowers atop mid green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-rugosa")])]), _vm._v(" (rew-go' sa)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Anise Hyssop")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("24-30\"/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet-rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China, Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("This oriental visitor is offered by a number of nurseries because of enhanced cold tolerance. The branching flower stems carry violet-rose whorled flowers on 2-3' tall plants over fragrant foliage. The wonderfully mint-scented leaves are 2-3\" long and 2\" wide with serrated margins and are pubescent chiefly along the veins on the underneath. Not as ornamental as some of the hybrids but a good performer.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ is a white-flowered form of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Honey Bee Blue’ is a uniform long-flowering cultivar. Plants received an Award of Quality from Fleuroselect, an association of flower seed breeders and sales companies in europe, similar to our All American Selection association.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Honey Bee White’ is similar to ‘Alba’ and may be the same. The creamy white flowers bloom for a long time on 2-3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-rupestris")])]), _vm._v(" (rew-pes' tris)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rock Anise Hyssop")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Salmon-orange")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southwest United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("The striking rosy-orange whorled flowers and gray-green foliage provide a lovely wildflower to add color to the garden. One of the hardiest of the native hyssops, it has been used to incorporate cold tolerance to a number of hybrids. The flower color is unusual and flowering persists for at least 8 weeks. The best part of these plants is the fragrance of the foliage. People keep coming back to get their sniff, then bring their friends to get theirs. I call it the licorice plant, and plants transport me to the old-fashioned candy store. A Plant Select"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("®")])]), _vm._v(" Winner in 1987.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Full sun and well-drained soils are necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_c('strong', [_vm._v("Hybrids")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Apache Sunset’ produces gray, finely cut leaves on 18-22\" plants with salmon-orange flowers in midsummer to late fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Apricot Sprite’ and ‘Apricot Sunrise’ are stunning crosses between "), _c('em', [_vm._v("A. aurantiaca")]), _vm._v(", golden hyssop, and "), _c('em', [_vm._v("A. coccinea")]), _vm._v(", both hybridized by Richard Dufresne of North Carolina. The former is about 2' tall and filled with apricot flowers in the summer. The latter is taller, up to 3 1/2' with many golden orange tubular flowers in the summer. Both are eye-catching and attractive to butterflies and hummingbirds. Water and fertilize well. Zones 7-9.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Black Adder’ appears to be a cross between "), _c('em', [_vm._v("A. foeniculum")]), _vm._v(" and "), _c('em', [_vm._v("A. rugosa")]), _vm._v(". It is a long bloomer, usually starting in midsummer and flowering until September or October. The flowers are rosy violet and held well above the foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0048-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Agastache rupestris")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("‘Blue Fortune’ is also a cross between "), _c('em', [_vm._v("A. foeniculum")]), _vm._v(" and "), _c('em', [_vm._v("A. rugosa")]), _vm._v(", and is without doubt one of the best new plants recently introduced to gardens. Plants can grow up to 3' in height and bear beautiful lavender-blue flowers on upright spires. The foliage has lovely licorice-scented leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Coronado’ is an upright grower with silvery aromatic leaves. The tubular yellow flowers are heavily stained with orange, and open in late summer. Plants grow about 2 1/2' tall. I have seen this rated to be hardy as far north as zone 4, but more likely to zones 5-6. Selected a winner by Colorado’s Plant Select"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("®")])]), _vm._v(" Program in 2001.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("‘Firebird’, also from Richard Dufresne, is a hybrid of "), _c('em', [_vm._v("A. coccinea")]), _vm._v(" and "), _c('em', [_vm._v("A. rupestris")]), _vm._v(" and bears many orange-salmon flowers on 3' tall plants. Plants are fuller than either of the parents and are cold hardy to zone 6. Terrific plant for hummingbirds. Probably hardy to zone 8, perhaps zone 7.")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fragrant Delight’ produces pale blue flowers on 3' tall stems. The foliage is particularly fragrant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Heather Queen’ is 2' tall with many rosy pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just Peachy’, introduced by High Country Gardens of Santa Fe, New Mexico, provides subtle shades of pink- and peach-colored flowers. The 2 1/2' tall plants are perhaps hardy to zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pink Panther’ ("), _c('em', [_vm._v("A. coccinea")]), _vm._v(" x "), _c('em', [_vm._v("A. mexicana")]), _vm._v(") grows 3-4' tall and produces many 1 1/2\" long tubular rose-pink flowers held in long racemes, starting in midsummer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Purple Haze’ is only about 2' tall, taller in warmer weather, with lavender flowers in the summer. Not as fragrant as many other hybrids, but plants are consistently hardy to zone 6. Plants were introduced by Dutch plantsman Coen Jansen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Red Fortune’ did not come as a sport of ‘Blue Fortune’, thus one should not give the high grades of the latter to this plant. However, having said that, it is still a fine introduction, more like a dwarf form of ‘Tutti Frutti’. Probably a hybrid of "), _c('em', [_vm._v("A. mexicana")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Shades of Orange’ was also introduced by High Country Gardens. Plants are about 2 1/2' tall and produce many tubular blooms from peach to dark orange. Zones 6-10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Summer Breeze’ is becoming better known as more plants find American gardens. Introduced by Canyon Creek Nursery in northern California, plants are 3-4' tall and bear dozens of apricot-orange flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Summer Lustre’, also from Canyon Creek, is even more vigorous, easily attaining 4-5' in height if not trimmed. Flowers are peach colored with a hint of pink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tutti Frutti’ ("), _c('em', [_vm._v("A. barberi")]), _vm._v(" x "), _c('em', [_vm._v("A. mexicana")]), _vm._v(") has tubular pink flowers from midsummer to frost. The foliage, to some noses, smells like tutti frutti. What does tutti frutti smell like anyway? Many people like this plant, but I was not one of them until I saw plants in Chanticleer Garden in Pennsylvania. They were upright, colorful and an exciting part of the garden; I am a born-again tutti-man. Hardy to zones 7-8.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("Ageratina")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("See "), _c('em', [_vm._v("Eupatorium rugosum")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("Ajania")])]), _vm._v(" (a-jan-ee' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Silver and Gold")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Ajania pacifica")]), _vm._v(" is the accepted name for plants that were classified as "), _c('em', [_vm._v("Chrysanthemum pacificum")]), _vm._v(", and although its name has changed, the beauty and the challenges have not. This native Japanese species grows 1-1 1/2' tall and bears late yellow pom-pon flowers in late fall. Plants potentially offer a little something for everybody. The foliage is the most ornamental part of the plant, providing mounds of light green leaves edged in well-defined narrow bands of silver throughout the spring and summer. As early as late September and as late as October and November, dozens of flower buds give rise to bright golden yellow buttonlike flowers providing some of the brightest color in the fall garden. They are particularly handsome growing through gray-leafed plants such as "), _c('em', [_vm._v("Artemisia")]), _vm._v(" ‘Powis Castle’ but also are wonderful container plants that can be used as a substitute for fall mums. Because of the outstanding contrast between the bright flowers and the variegated foliage, garden centers offer them for sale as both spring and fall plantings. Plants perform reasonably well in zones 5-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, not all is rosy in silver and gold land. Plants have been plagued with reports of poor winter hardiness, disappearing for no apparent reason. However, such death is as much a problem of poor drainage as cold temperatures. Provide excellent drainage and full sun but regardless, they should not be expected to give more than 3 years of good performance. Enjoy them, then replace with something else. Propagate by terminal cuttings in the spring or summer.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Ice’, introduced in this country in 1994, has light pink petals around a yellow center over 18\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Ajuga")])]), _vm._v(" (a-jew' gah)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Bugle Weed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Lamiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Bugle weed is one of the best-known perennials, even to non-gardeners. Plants popular with “normal” people are those that are easily grown, spread well, and provide good flowers and foliage, all without maintenance. "), _c('em', [_vm._v("Ajuga")]), _vm._v(" grows in any reasonably well-drained soil and although tolerant of full sun, growth is more rapid in partial shade. "), _c('em', [_vm._v("Ajuga reptans")]), _vm._v(" can become a persistent weed particularly if planted on the edge of a lawn, but other slower-growing species are available.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Approximately 40 species are known, however, only three have become available to American gardeners. Flowers are usually violet-blue although pink- and white-flowered cultivars have also been developed. All have square stems, opposite leaves and whorled flowers. A large drift in full bloom is spectacular but the foliage is the main reason for its popularity. In the South, crown rot (caused by "), _c('em', [_vm._v("Sclerotium rossii")]), _vm._v(") can be a problem, particularly with "), _c('em', [_vm._v("A. reptans")]), _vm._v(". Entire plantings may die or large patches develop infection. Planting in well-ventilated areas, dividing every 2-3 years, and applying fungicides help reduce this problem. Cut away and dispose of affected leaves and often plants recover without long-lasting damage when temperatures cool down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed should be sown in late summer for fall planting or in November for spring planting. Cultivars will not come true to type from seed but cuttings and divisions may be used. Division is the easiest method and may be accomplished any time the ground is workable. Tissue culture techniques have also been developed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Ajuga Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Stoloniferous (Y or N)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Stems (erect or prostrate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. genevensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Prostrate")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. pyramidalis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Erect")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. reptans")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Y")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Prostrate")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-genevensis")])]), _vm._v(" (gen-e-ven' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Geneva Bugle Weed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/9\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species is becoming more popular because it produces fewer runners, therefore spreads much less vigorously than "), _c('em', [_vm._v("A. reptans")]), _vm._v(". Plants, however, grow faster than "), _c('em', [_vm._v("A. pyramidalis")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("If constant moisture is provided, it tolerates more sun than "), _c('em', [_vm._v("A. pyramidalis")]), _vm._v(" or "), _c('em', [_vm._v("A. reptans")]), _vm._v(". The dark green basal leaves are coarsely toothed, not hairy, and about 3\" long. The upper leaves are 1-3\" long, sessile and only slightly serrated. The stems are coarsely hairy, which makes it different than common bugle weed. The 4-6\" tall ")]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("flower spikes are often pink but may be blue or white. Although most "), _c('em', [_vm._v("Ajuga")]), _vm._v(" grow in zone 3, this species should receive winter protection in zone 4.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ bears creamy white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Beauty’ is 4-5\" tall with light pink flowers in May and June.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robusta’ is more vigorous and produces larger flowers and bigger foliage. Flowers are lavender-blue.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosea’ has rosy-pink flowers but is otherwise identical to the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tottenham’ (‘Tottenham Blue’) is the best cultivar, bearing dense spikes of lilac-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegata’ has dark green leaves, mottled creamy white.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-pyramidalis")])]), _vm._v(" (pi-ra-mid-ah' lis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Upright Bugle Weed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/9\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("(syn. "), _c('em', [_vm._v("A. alpina")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This good-looking plant incorporates the fine flowers and dark foliage of "), _c('em', [_vm._v("A. reptans")]), _vm._v(" without the spreading habit. The basal rosette is slightly toothed and hairy. The stems are hairy and the 4-6\" long flower spikes consist of large purple bracts which appear to press against the blue flowers. The leaves subtending the flowers are 2-4 times as long as the violet-blue flowers. Although the plant does not spread as rapidly as "), _c('em', [_vm._v("A. reptans")]), _vm._v(", it does produce short stolons late in the season in response to short days.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ produces crinkled oval leaves and white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Metallica-crispa’ (‘Crispa’) has deep blue flowers and brownish red crinkly foliage with a metallic luster. Ugly as sin, but nevertheless, an outstanding garden plant. Also listed as ‘Metallica-crispa Purpurea’ and ‘Min Crispa Red’.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-reptans")])]), _vm._v(" (rep' tanz)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Bugle Weed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-12\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Much of the breeding and selection in this genus has been accomplished with "), _c('em', [_vm._v("A. reptans")]), _vm._v(" and remarkable advances in foliage color have resulted. Regardless of cultivar, "), _c('em', [_vm._v("A. reptans")]), _vm._v(" is stoloniferous and can spread rapidly. This characteristic makes this species an excellent ground cover and a large clump in flower is a spectacular sight. Plant where its invasive qualities are welcome, such as on a bank or under the dappled shade of trees. Do not plant it as an edging to the lawn or the insidious disease of “buglelawn” will occur. One of the symptoms includes the appearance of small islands of green foliage soon forming a large archipelago in an ocean of lawn. Weapons to destroy these islands include shovels, sprayers, or as one gardener did, simply expanding the flower bed to include all the bugleweed in the lawn. His lawn became smaller every year. (Hmmm, perhaps he is on to something.) The best prevention is proper planning; plan to keep the "), _c('em', [_vm._v("Ajuga")]), _vm._v(" away from all grassy areas. If all else fails, remember that the ingestion of leaves of "), _c('em', [_vm._v("A. reptans")]), _vm._v(" is a mild narcotic. After trying some of the leaves, buglelawn will not seem as serious.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Some may be hybrids with other species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Selections for flower color or size.")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ has creamy white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Linda Applegate’ is a reasonably compact form with white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Elf’ is a dwarf cultivar with clear pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Spire’ is a fine green-leaved cultivar bearing 7\" long pink flower spikes.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Surprise’ has bronze-green leaves, narrower than many others species’, and purplish pink flowers. Introduced by Terra Nova Nursery, Tigard, Oregon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Torch’ bears tall torches of 12\" lavender-pink flowers with glossy green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosea’ produces rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Selections for leaf color, all have blue to violet flowers")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Arboretum Giant came from Tony Avent of Plant Delights Nursery in Raleigh, North Carolina. This is a big robust plant whose large green leaves are outlined in deep purple. Bigger and uglier than ‘Catlan’s Giant’.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0052-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Ajuga reptans")])])]), _c('p', {
    staticClass: "bibp"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("‘Arctic Fox’ was introduced by Henry Ross, one of our great horticulturists, whose Gardenview Horticulture Park in Strongsville, Ohio is a must-see venue. ‘Arctic Fox’ bears small leaves with white centers and green margins, and blue flowers.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Atropurpurea’ (‘Purpurea’) has dark bronzy-purple leaves that color best in full sun. It is an excellent landscape plant to provide drifts of bronze.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Black Scallop’ produces deep purple, glossy foliage with a wavy or scalloped margin. The flowers are deep blue. Plants were developed by Mike Tristram of the UK.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bronze Heart’ bears glossy, wine-red leaves and deep blue flowers. Very eye-catching.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bronze Beauty’ produces metallic bronze foliage with bright blue flowers. Very popular, very handsome selection.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Burgundy Glow’ has foliage with shades of white, pink, rose and green. In the fall, the older leaves turn a deep bronze and the young leaves have a rosy tint. The combination is interesting if your eyes can stand the clashing hues.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Catlin’s Giant’ has tall (up to 8\" long) spikes of blue flowers and bronze-green foliage. Continues to produce fine foliage even after flowering and fills in rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Chocolate Chip™ (‘Valfredda’) rapidly became a popular plant soon after its introduction to this country in 2000. Plants are compact, dwarf and bear deep purple foliage. The flowers are also deep blue. Not as rapid a spreader as many other cultivars. They are occasionally sold under the correct name ‘Valfredda’, from the Italian nursery from which they originated. Arguments abound as to whether the plant is a cultivar of "), _c('em', [_vm._v("A. reptans")]), _vm._v(" or "), _c('em', [_vm._v("A. tenorii")]), _vm._v(", from the mountains of Italy and Sicily. Stay tuned.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cristata’ is probably one of the ugliest little plants available today. The leaves are crinkled and distorted and the whole plant looks like crumpled spinach. To each his own. May go under such names as ‘Ripple Leaf’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Emerald Chip’ supposedly came from Chocolate Chip™, resulting in a green chip. Same properties as Chocolate Chip™ but without the chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gaiety’ has bronze purple leaves and lilac flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Glow’ has light golden margins around the green centers of the leaves. A good selection where variegated ground covers are useful. The blue flowers are held on short stems in spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gray Lady’ produces classy gray-green foliage and blue flowers. Growth is relatively slow but clumps are most handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jungle Beauty’, originally introduced by Allen Bush when he owned Holbrook Farms in North Carolina, bears dark purple leaves outlined with a soft red border. A similar form known as ‘Jungle Beauty Improved’, selected by Beth Chatto in East Anglia, England, seems to have larger leaves and more persistent purple color. Both are good selections.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Leprechaun’ is a dwarf form with ugly spinach-like leaves. Want spinach? Grow spinach.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mahogany’ is another dark-leaved short form, similar to Chocolate Chip™, growing about 3\" tall and bearing bright blue flowers in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Multicolor’ (syn. ‘Rainbow’, ‘Tricolor’) is similar to, but more vigorous than ‘Burgundy Glow’ but the foliage colors are deeper. Sometimes comments concerning leaf colors are best left to the gardener. This is one of those times.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("‘Pink Silver’ produces bronze leaves with a touch of pink.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Brocade’ is 6-8\" tall, with deep purple brocaded leaves. A slow grower, but very handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Royalty’ has some of the darkest purple flowers (almost black) with scalloped edges. Terrific cultivar.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ruffled Lace’ came from plantsman extraordinaire Dr. Darrell Apps of Woodside Nursery in Bridgeton, New Jersey. It is a clumping form, producing burgundy leaves with ruffled edges. Blue flowers are formed in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Beauty’ has gray-green leaves irregularly edged with silver-white. Plants are particularly handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Carpet’ produces leaves which are uniformly silver-gray but with green margins. Plants are about 6\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Queen’ bears white splashes on gray foliage. Blue flowers are produced in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Toffee Chip’ is as compact as Chocolate Chip™ but bears variegated green and white foliage. Stands out in a crowd in a semi-shaded area.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. australis")]), _vm._v(" is native to Australia and is a 3-4\" tall mat former. The thick dark green pubescent (hairy) leaves are aromatic when crushed and the light blue flowers rise to about 8\" in height. Probably effective in zones 5-8. Underused and well worth trying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" ‘Brockbankii’ ("), _c('em', [_vm._v("A. genevensis")]), _vm._v(" x "), _c('em', [_vm._v("A. pyramidalis")]), _vm._v(") is smaller and more vigorous than common bugle weed. Plants have deep blue flowers and shorter stolons.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Alcea")])]), _vm._v(" (al-see' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Hollyhock")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Malvaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Approximately 60 species of biennial and short-lived perennial species are found and some of them are exceptionally popular. Hollyhocks ("), _c('em', [_vm._v("A. rosea")]), _vm._v(") have been gracing gardens for centuries and continue to undergo a renaissance in the United States. All species are found in sunny, well-drained habitats and provide exceptional color for short periods of time. Although hollyhock is the best-known member, one or two other species provide additional interest as well. Flowers are generally large and appear singly or in racemes and the stems are usually hairy. All can be grown from seed and require little more than sun and good air circulation.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("The genus is part of the Malvaceae, which contain genera such as "), _c('em', [_vm._v("Lavatera")]), _vm._v(", "), _c('em', [_vm._v("Malva")]), _vm._v(" and "), _c('em', [_vm._v("Sidalcea")]), _vm._v(". To me, many of these plants are difficult to distinguish, especially when people ask me “Why is that a hollyhock and not a malva, or lavatera or . . . ?” Since they are closely related and appear so similar, particularly to my leaden brain, I have to find a way to try to answer that question, without resorting to details seen only in a laboratory. If people should be silly enough to ask, I grab a flower, turn it over and say “Look at the bracts.” They seldom ask again. Upon close inspection, "), _c('em', [_vm._v("Alcea")]), _vm._v(" differs from other genera by having 6-9 bracts (botanically known as the epicalyx) immediately beneath the sepals and they completely envelop the emerging bud. Also, the bracts are joined rather than separate as in the genus "), _c('em', [_vm._v("Malva")]), _vm._v(". This seems a little ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("much for some, but for others it is quite enlightening. For those who like to be lit up, I have provided a basic chart to help discriminate between these genera. Unfortunately, hybrids muddle up this simple scenario, but it is a start.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Bracts below sepals")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Flower arrangement")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Alcea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6-11, joined at base")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Solitary, raceme")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Althaea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6-9, united at base")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Raceme, panicle")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Lavatera")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3, joined, pointed")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Raceme")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Malva")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3, narrow, distinct")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Solitary, clusters")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Sidalcea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Usually none")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Raceme, spike")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-rosea")])]), _vm._v(" (rose-ee' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hollyhock")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-8'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring, Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mixed Colors")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother knew very little about gardening, other than that the lawnmower was a good way to keep her sons out of trouble. But how she loved her hollyhocks. They grew with their backs up the stucco wall of our garage, held up with ugly white strings that extended from rusty nails on either side. Like tape measures across a boxer’s chest, these strings were often more visible than the plants. But every year, they would come back from roots or seeds and provide a riot of color along an otherwise drab path. By midsummer, the leaves were eaten up by rust but by that time, hollyhocks gave way to other activities and thus ignored, disappeared once again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She would be pleased to see hollyhocks today. The old red single flowers are still around, but so are many other colors and forms, including double flowers and saucersized singles, up to 5\" across. Plants are generally 3 to 6 feet tall, but 8' monsters are not uncommon. They are unbranched, thus are rather pole-like, and the stems are hairy to the point of being bristly. The leaves have 3, 5 or 7 lobes and the flowers occur in terminal racemes, made up of 3-10 flowers. The 6-11 bracts beneath the flowers are joined and turn brown as the flowers mature. Cultivars today are also less susceptible to the nemesis of hollyhock, hollyhock rust. Caused by a fungus, "), _c('em', [_vm._v("Puccinia malvacearum")]), _vm._v(", orange-brown pustules occur on the undersides of the leaves and stems. If my mother had known that the spores overwintered on the blistered, ignored leaves by the garage, she would have removed them. Actually, she would have told her sons to do it, and we would have probably taken the trusty Lawn-Boy to them. Fungal sprays are available, removing any affected leaves and rotating cultivars from year to year is much more effective.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Japanese beetles can also crunch, chew, disfigure and destroy hollyhocks within days of their arrival. Japanese beetles love most members of the Malvaceae, and they can be sprayed, picked off, or crushed between two bricks. Regardless, if you have Japanese beetles, think twice about giving them hollyhocks for dessert.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by planting seeds directly in the prepared soil immediately after the last frost date or in containers about two weeks before that time. If sowing in containers, place the container at 72-75°F and cover the moist soil with a plastic until the seedlings emerge. Do not germinate the seeds too early or plants will be weak and stretched before the transplant date.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Single flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barnyard Mix is offered by an enterprising nursery who claim seeds were collected from an old barnyard in Vermont. They are single, in various colors, tall and old-fashioned. I bet they collected them from my mother’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Black Beauty’ has deep purple to almost black flowers on 6' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Indian Spring’ is available in white, yellow, rose and pink. Plants are 7-8' tall. This has been around for quite a while, as noted by its AAS selection in 1949.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nigra’ has some of the deepest purple flowers of any cultivar. Plants attain about six feet in height.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Simplex’ is a mixture of colors on 4-5' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Watchman’ has deep purple flowers on 5-6' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Double, semi-double flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Appleblossom’ bears large light pink to rose fully double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Chaters Double Hybrids occur in a range of colors. Each double flower resembles a ruffled peony. Plants in single colors may be purchased including ‘Chaters Pink’, ‘Chaters Scarlet’, ‘Chaters Violet’, ‘Chaters White’ and ‘Chaters Yellow’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Crème de Cassis’ produces mostly semi-double 3-4\" wide flowers of burnished purple with yellow centers. Some flowers may also be single. The petals are also wavy. An interesting look and color.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fruity Mix is a mixture of pink and rose, bloated, fully double flowers. To each his own.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nigrita’ has dark, almost purple-red double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Peaches ’n’ Dreams’ bears many fully double, peach and raspberry flowers on 4-6' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pinafore’ is more branched and compact than other cultivars and bears semi-double flowers in numerous colors. Plants are 3-4' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Powder Puffs’ grows 6-8' tall and produces 4\" wide fully double flowers in white, yellow, rose and red.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Queeny series is a seed-propagated mix of semi-double flowers on short (2-3' tall) plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Queeny Purple’ was an All-America winner in 2003. ‘Summer Carnival’ is name given for a mixture of colors with double blooms on 2 1/2-3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('em', [_vm._v("A. ficifolia")]), _vm._v(" has many common names including figleaf hollyhock, Antwerp hollyhock and Russian hollyhock. The leaves are 7-lobed, irregularly toothed and resemble fig leaves, probably the best means of identification. Flower color is all over the map, many being pale yellow (most common) to deep red, copper or orange. These are robust plants and will easily attain 6' tall. They are native to Siberia, and their exceptional cold hardiness has made them popular as a parent for the many hybrids of hollyhocks hitting the market today. In the Gardens at UGA, plants are 5' tall, have nary a smudge of leaf disease, and bear dozens of velvet flowers. Outstanding. ")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Hybrids of "), _c('em', [_vm._v("A. rosea")]), _vm._v(" and "), _c('em', [_vm._v("A. ficifolia")]), _vm._v(" with single flowers have been released as ‘Summer Memories Mix’.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rugosa")]), _vm._v(", Russian hollyhock, is becoming more popular due to its classical nature and fewer problems with hollyhock rust. The large 4\" wide single flowers are pale yellow and the leaves are deeply 5-lobed. The 5-6' tall stems are hairy all over. This can be a terrific plant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Genus:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Althaea")]), _vm._v(", also known as hollyhock, is often confused with "), _c('em', [_vm._v("Alcea")]), _vm._v(", for obvious reasons. Most of the ornamental hollyhocks belong to "), _c('em', [_vm._v("Alcea")]), _vm._v(". The flowers of "), _c('em', [_vm._v("Althaea")]), _vm._v(" are smaller, seldom exceeding 1-1 1/2\" wide and usually rose, rose-pink or occasionally white. While not as flashy as "), _c('em', [_vm._v("Alcea")]), _vm._v(", they are useful for naturalistic plantings. Approximately 12 species are known; the 3-5' tall "), _c('em', [_vm._v("A. officinalis")]), _vm._v(", which has small rose, pink or white flowers, is best known. The roots of this species were the original source of marshmallows.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Alchemilla")])]), _vm._v(" (al-kem-ill' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Rosaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("The genus may have received its name because of its popularity with alchemists and was reputed to have many healing powers. Today we know it as a wonderful low-growing shade tolerant plant with sprays of small yellow flowers in the spring. Some 300 species are known, most of which are palmately lobed and make excellent garden plants. The foliage is light green, pubescent and soft to the touch, particularly on the underside. The apetalous (no petals) flowers are only about 1/4\" wide and range from green to yellow. Although many species have been described, only two or three are easily located through catalogs or retail centers in the United States and Canada.")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Alchemilla requires partial shade and consistent soil moisture to thrive. Plants will be stunted if planted in full sun or allowed to dry out. Cool climates are preferable but they do quite well as far south as zone 7 providing there is ample shade and moisture. I have grown lady’s mantle in Athens, Georgia and it is lovely to those who have never seen large drifts grown under favorable conditions, however, the luxuriant growth taken for granted further north is never attained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fresh seed germinates readily but purchased or old seed should be given a cold treatment similar to "), _c('em', [_vm._v("Actaea")]), _vm._v(". "), _c('em', [_vm._v("Alchemilla")]), _vm._v(" self-sows readily which helps increase the planting size. Plants should be divided in early spring prior to flowering.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Alchemilla Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Lobes cut more than half way")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Hairiness on leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. alpina")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lower surface")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ellenbeckii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Both surfaces")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. erythropoda")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Both surfaces")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. glaucescens")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("9-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Both surfaces")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. mollis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("20-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Both surfaces")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-alpina")])]), _vm._v(" (al-pine' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mountain Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every time I redo this book, I seem to repeat myself; that is, this species is not used enough in the United States. The flowers may not be extraordinary but the silver edges of the deeply cut 2\" wide foliage and the low neat habit make this a wonderful garden plant. The 5-lobed leaves have small, sharp teeth at the end of each lobe and are hairy on the lower surface only, being kind of naked above. Self-seeding is common, and if this becomes a problem, the seed heads may be removed prior to maturity. I have never had that problem in the Armitage garden, being happy just to keep plants alive. Reseeding is more common in the North than in the South. It is native to mountainous areas and as far north as Greenland. Cold hardiness is not a problem in most of the northern states and Canada but they are not as heat tolerant as "), _c('em', [_vm._v("A. mollis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ellenbeckii")])]), _vm._v(" (el-len-beck-ee' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Carpet Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-6\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow-green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("East Africa")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This shade-loving little plant also deserves more use in American gardens. The diminutive height and spreading nature make this a charming ground cover for a shady nook. The 1\" wide leaves are deeply 5-lobed and the plant spreads by rooting at the nodes. The yellow-green flowers are not as freely produced as on the larger species but are handsome nevertheless. Plants are not as cold hardy as others but should be fine to zone 5 with some protection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are best propagated vegetatively by division.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-erythropoda")])]), _vm._v(" (e-rith-ro-po' da)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Red-stemmed Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow-green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Similar to other medium-sized species but with small scalloped gray or blue-green leaves and dense hairs on the petioles (leaf stalks). These diminutive plants often develop red stems when grown in a partially sunny location. The lobes of this species look like they were cut across their width with pinking shears whereas the lobes of similar species are rounded. What some people will study!")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-glaucescens")])]), _vm._v(" (glock' es-sends)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hairy Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("9-12\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring, Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow-green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This small plant is densely hairy throughout and bears circular leaves with 7-9 shallowly cut lobes. The kidney-shaped foliage may be slightly blue-green (glaucous) but not always. Dense clusters of yellow-green flowers are produced in late spring and into summer. Similar to "), _c('em', [_vm._v("A. erythropoda")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-mollis (mol' lis)")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("20-24\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellowish")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Asia Minor")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("This is grown at least ten times more often than all the other species combined. The common lady’s mantle is a splendid ground cover and will grow in almost any ")]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("moist, shady area except a bog. The dense pubescence gives the foliage a soft velvet feel. Leaves have 9-11 shallow lobes and are particularly pretty after a soft rain when the captured droplets glisten in the sun. The yellow-green starry flowers, which are held above the foliage, make long-lasting cut flowers. When grown side by side, the flowers are obviously the most showy of any of the commonly seen "), _c('em', [_vm._v("Alchemilla")]), _vm._v(" species. This species may be too large for the rock garden but can be used successfully to edge a path or border. The densely hairy leaves create a problem in areas such as the Southeast where thundershowers punctuate hot summer afternoons. The water trapped in the leaves and crown does not dry out during the night and provides excellent breeding grounds for a number of foliar diseases. Use of a fungicide during wet, rainy periods partially alleviates the problem.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0059-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Alchemilla mollis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Auslese’ is offered by a few nurseries and differs little from the species. Perhaps the flowers are more chartreuse and plants are a little more compact.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robusta’ is more robust and simply larger in every way than the species. However, since most of the "), _c('em', [_vm._v("A. mollis")]), _vm._v(" in cultivation is propagated from seed, there may be little difference between a vigorous seedling and this cultivar.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("‘Senior’ is shorter than the species, growing only about 12\" tall.")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Thriller’ has large pleated leaves with many chartreuse foamy flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although "), _c('em', [_vm._v("A. mollis")]), _vm._v(" dominates, many other species are offered, which are generally less vigorous but equally beautiful. In general, however, lady’s mantle, regardless of species, is still more suited to areas where summer night temperatures routinely fall below 70°F.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. abysinnica")]), _vm._v(", Abyssinnian lady’s mantle, is similar in spreading habit but differs in having larger (2\" across) 7-lobed leaves. Also native to East African mountains. Little is known about hardiness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. caucasica")]), _vm._v(", Caucasus lady’s mantle, is indistinguishable from "), _c('em', [_vm._v("A. erythropoda")]), _vm._v(", differing mainly in the arrangement of the hairs on the flowering stems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. conjuncta")]), _vm._v(" is closely related to "), _c('em', [_vm._v("A. alpina")]), _vm._v(" and is often sold as such. Plants are a little more robust, growing 12-18\" tall. Leaves generally have 7 deep cut lobes but without the sharp teeth found in "), _c('em', [_vm._v("A. alpina")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. faeroensis")]), _vm._v(" is another small plant, growing only 3-6\"tall. I have grown this in my garden, and one would think that a plant native to the Faeroe Islands would quickly perish in Athens. However, it came back for at least 10 years, and while never overly showy, I always enjoyed it. var. "), _c('em', [_vm._v("pumila")]), _vm._v(" is a smaller form yet and terrific for rock gardens, but can easily get lost if crowded with other more vigorous taxa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pectinata")]), _vm._v(" is the neatest lady’s mantle I have seen. Plants produce exceedingly long stems and they are best suited for hanging baskets or tumbling from a stone wall. Dull green leaves and soft yellow flowers are part of the plant’s charm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. saxatilis")]), _vm._v(", rocky lady’s mantle, is only about 6-9\" tall, and is normally found in alpine locales, growing among rocks. The foliage has 5 lobes, light green on the top, silvery on the underside. Great for the rock garden, but not the “regular” garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sericea")]), _vm._v(" is similar to "), _c('em', [_vm._v("A. alpina")]), _vm._v(" but has more conspicuous and irregular teeth in the upper half of the leaves. The upper surface of the leaves have small hairs, whereas those of "), _c('em', [_vm._v("A. alpina")]), _vm._v(" are smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. vulgaris")]), _vm._v(", common lady’s mantle, is similar to "), _c('em', [_vm._v("A. mollis")]), _vm._v(" but is less pubescent and has much smaller, greener flowers. The foliage is also more deeply lobed. Most of the plants of "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" sold in the United States are "), _c('em', [_vm._v("A. mollis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. xanthochlora")]), _vm._v(" is a relatively large plant like "), _c('em', [_vm._v("A. mollis")]), _vm._v(", growing 15-20\" tall. The plant differs in that the leaves are almost hairless on the upper surface and are more kidney shaped compared to the circular leaves of "), _c('em', [_vm._v("A. mollis")]), _vm._v(". Good garden plants with chartreuse, airy flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Allium")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Ornamental Onion")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Alliaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("I have always enjoyed growing ornamental onions. They allow me to converse with vegetable gardeners without feelings of guilt. While they don’t garnish my hamburgers, they certainly embellish my garden. The genus contains approximately 500 species including onions ("), _c('em', [_vm._v("A. cepa")]), _vm._v("), garlic ("), _c('em', [_vm._v("A. sativum")]), _vm._v("), and chives ("), _c('em', [_vm._v("A. schoenoprasum")]), _vm._v("). Although ornamental forms of chives such as the rosy pink ‘Forescate’ have been ")]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("developed, the presence of these tasty but breathy members of the onion family has given the ornamental alliums a particularly difficult time in the marketplace. The species are bulbous or rhizomatous and are all characterized by the presence of a superior ovary, umbels of small flowers and the emission of an onion or garlic smell when crushed. The flowers consist of many petal-like flower parts called tepals. Scientists in several locations have tried to eliminate the odor from alliums, particularly the culinary species, but I, for one, hope they have little success. An allium without odor is like a book without a cover. The odor occurs only when plants are broken or crushed and is not given off spontaneously. In fact, the flowers of some members have a mild fragrance of violets.")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The family that "), _c('em', [_vm._v("Allium")]), _vm._v(" calls home is in flux. It was a part of the Liliaceae because of the superior ovary but some taxonomists argued that the presence of the umbel-late inflorescence should place "), _c('em', [_vm._v("Allium")]), _vm._v(" in the Amaryllidaceae. Others then argued for a separate family, Alliaceae, to be created for all genera with a superior ovary and an umbellate inflorescence. After the smoke cleared, it appears "), _c('em', [_vm._v("Allium")]), _vm._v(" and 20 other genera, such as "), _c('em', [_vm._v("Agapanthus")]), _vm._v(", "), _c('em', [_vm._v("Brodiaea")]), _vm._v(", and "), _c('em', [_vm._v("Ipheion")]), _vm._v(" belong to this onion family. Most gardeners don’t really care, but now you know why you don’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The number of species has also always been in question. When Linnaeus (1707-1778) wrote "), _c('em', [_vm._v("Species Plantarum")]), _vm._v(" in 1753, he distinguished 30 species. Many additional species were described since Linnaeus and continue to be discovered today. There is no modern monograph of "), _c('em', [_vm._v("Allium")]), _vm._v("; the last work that embraced all the known species was produced by Eduard von Regel (1815-1892) in 1875 and included 256 species. Other botanists have placed the number at 325 (1925), 400 (1976) and 700 (1987). William Stearn took the major accounts of the genus and subtracted species listed in other accounts and added those not covered in any. Stearn concluded that the genus "), _c('em', [_vm._v("Allium")]), _vm._v(" comprises about 750 known species and is the largest genus of petaloid monocotyledons. Two things are self-evident. That the genus is large, and that any self-respecting "), _c('em', [_vm._v("Allium")]), _vm._v(" geek will be hard-pressed to run out of onions to plant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ornamental alliums range in size from the 2-3\" tall plants of "), _c('em', [_vm._v("A. circinatum")]), _vm._v(" to the 4' tall scapes of "), _c('em', [_vm._v("A. giganteum")]), _vm._v(". Although many onions bear lilac-blue flowers, some species send up umbels of white ("), _c('em', [_vm._v("A. neapolitanum")]), _vm._v("), pink ("), _c('em', [_vm._v("A. acuminatum")]), _vm._v("), mauve ("), _c('em', [_vm._v("A. validum")]), _vm._v("), yellow ("), _c('em', [_vm._v("A. moly")]), _vm._v("), greenish ("), _c('em', [_vm._v("A. obliquum")]), _vm._v(") or interesting multicolors. Most species bear 3-8 linear leaves (except "), _c('em', [_vm._v("A. karataviense")]), _vm._v(") that die back before or soon after flowering. While most species are native elsewhere, a number of fine forms native to America occur, including "), _c('em', [_vm._v("A. canadense")]), _vm._v(" and "), _c('em', [_vm._v("A. texanum")]), _vm._v(", both about 1 1/2' tall and both with white flowers. The seed heads are persistent in many species and extend the ornamental value of plants well into summer.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("In general, the planting depth of the bulb should be approximately 3 times the diameter. Bulbs should be fall planted in full sun and in well-drained areas. As lovely as many of these species are, they are poor plants if not combined with other perennials or annuals. Because the foliage dies during or immediately after flowering, many gaps in the garden eventually exist. Planting in ground covers or having other plants growing around them camouflages the empty spaces. That there are so many onions running around out there should be a warning that not all are as wonderful as the ")]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("photo or catalog says they are. Some can look weedy, others can be aggressive and many will be short lived. Given that as a suitable warning, enjoy as many as you can stand. However, an area devoted strictly to alliums (or any genera of bulbs) is a collection, not a garden, and should be avoided like the plague.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Allium Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Fragrant flowers")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowering time")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. acuminatum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. aflatunense")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. caeruleum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. christophii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Violet")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. giganteum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("36-60")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. karataviense")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. moly")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. narcissiflorum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink-rose")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. neapolitanum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. nigrum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. oreophilum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Violet")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. schubertii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. senescens")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac-pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. sphaerocephalum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. thunbergii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Violet")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. triquetrum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-acuminatum")])]), _vm._v(" (a-cum-in-aye' tum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Tapertip Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-12\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two or four narrow, channeled leaves emerge from a round bulb, above which an 8\" scape holds erect, star-shaped flowers with pointed segments. Many 1/2\" long flowers form a loose umbel approximately 2\" wide. The 10-30 flowers range from deep rose to lilac-pink and bloom for about 2 weeks starting the end of May. Leaves are usually withered by flowering time. Plants do best in dry areas, and in hot, rainy, climates such as the Southeast, do not often persist more than 2 years. Plant in a well-drained sunny location. Flowers dry well when cut from the garden, retaining color when placed in a warm dry room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is a pretty plant when used in colonies of at least a dozen bulbs. Bulbils that form at the base of the bulbs result in a slow-spreading colony.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-aflatunense")])]), _vm._v(" (a-fla-tun-en' se)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Persian Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("This tall allium produces fine 4\" diameter spherical umbels of star-shaped flowers atop 3' tall scapes. The lilac to violet flowers have yellow anthers and tend to twist ")]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("and reflex with age. Often thought of as a smaller version of "), _c('em', [_vm._v("A. giganteum")]), _vm._v(", it lacks the majesty and grandeur of the latter. The bulbs, however, are available at one-third the cost and allow the gardener to plant onions with abandon. The 6-8 basal, strap-shaped basal leaves are up to 4\" wide and disappear soon after the flower appears.")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the few species in the genus truly at home among other plants in the border. Plants do well in any sunny well-drained location, however, they are susceptible to root rot organisms prevalent in heavy soils. I have seen wonderful plantings in Philadelphia gardens and as far north as Cleveland. Results in the South have been variable. Some years it is outstanding, others years, disappointing. This may be due to the fact that a number of impostors are sold under the banner of "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(". As cut flowers, they are excellent and last nearly 2 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed should be sown in moist seed trays and placed at about 70°F for 2-4 weeks, then placed at 30-40°F for an additional 4-6 weeks. After the cold treatment, bring the tray to 50-60°F until germination occurs. Keep moist at all times. Plants self-sow on the West Coast and occasionally in the Northeast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Sensation’ has deeper violet flowers which are more uniform than the species. A little more expensive but more handsome. I have seen this plant all over the country, and while it is not perfect everywhere, it is always colorful, upright and an inexpensive addition to the garden. They were spectacular in combination with colorful annuals in beds and containers at the must-see North Carolina Botanical Garden in Asheville, NC. A number of outstanding hybrids using "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(" as a parent have been developed (see hybrids).")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-caeruleum")])]), _vm._v(" (ce-rue' lee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue Globe Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-24\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Russia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 2-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The deep blue flowers are held very tightly in a 1-2\" diameter umbel. The leaves are 3-sided and 6-12\" long. The cup-shaped flowers, which open in late May in zone 7 and about 2 weeks later in zone 3, persist for about 2 weeks and make excellent fresh or dried flowers. Unfortunately, it is difficult to establish in most American gardens as it comes from the steppes and deserts of Central Asia and requires hot, dry conditions to flourish. Plants may be divided easily to provide good-sized clumps. Occasionally bulbils are formed within the inflorescence (particularly on var. "), _c('em', [_vm._v("bulbiliferum")]), _vm._v(") and may be used for propagation. Seed should be treated as with "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-christophii")])]), _vm._v(" (kris-tof' ee-eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Downy Onion, Star of Persia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("15-24\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Afghanistan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although short in stature, this is one of the largest flowering species in cultivation. Up to 100 metallic blue star-shaped flowers are carried on a spherical umbel often 10-12\" in diameter. The stems and the margins of the 2-7 strap-shaped leaves are covered with white hairs that are responsible for the common name. The leaves die before the flowers have completely opened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When in flower, there is no more eye-catching member of the genus. It is also one of the best alliums for long-lasting dried flowers, looking good literally for years. A sunny, well-drained area at the front of the border is necessary for best performance. Excellent hybrids, in particular ‘Globemaster’ (which see), have been developed with this species as a parent.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0064-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Allium")]), _vm._v(" ‘Globemaster’")])])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "indentp"
  }, [_vm._v("Propagate by seed similar to "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-giganteum")])]), _vm._v(" (gi-gan' tee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Giant Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Central Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zone 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("This is, as the name implies, the giant of this genus. The bulb itself is 2-3\" in diameter and resembles a large, round ball. In early spring, 6 to 9 broad (5-8\" wide) gray-green leaves emerge as a rosette followed by a thick, strong scape (flower stem) carrying the many lilac flowers. By the time the scape is 6-12\" long, the leaves lie on the ground. Three to four weeks are required for the scape to grow to a final height of 4' but the wait is justified. There are over 100 individual flowers, each 1/2\" long, which are held closely together in a dense, 4\" diameter rounded umbel. The round seed heads are equally beautiful, turning silver-tan color as the flowers age.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant in groups of three, more if you can afford more, in full sun and well-drained soils. It is an excellent late spring and early summer flower for the back of the border and because the leaves disappear soon after flowering, there is no “dead time” waiting for the leaves to wither as with tulips and daffodils. Plantings as far south as zone 8 have been excellent and if mulch is applied, the bulbs appear to be cold tolerant to zone 4. In zone 8, flowering occurs in mid May but not until early June in Michigan (zone 4). As a cut flower it is outstanding, and has gained much popularity with florists and designers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Propagation is accomplished by separating the two portions of the bulb which tend to split after 2 years.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-karataviense")])]), _vm._v(" (ka-ra-tah-vee-en' se)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkistan Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/15\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Silver-gray")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Afghanistan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("This unique species is grown for the foliage as much as for the flowers. The thick, gray-green leaves (usually 2) are up to 4\" wide and mottled purple, particularly underneath and near the base. Many people feel that the leaves are more ornamental than the flower, which is a rather washed-out silver-lilac. I am not one of them. The dense umbels are 6-8\" across and compete with those of "), _c('em', [_vm._v("A. christophii")]), _vm._v(" for the largest in the genus. The plant is particularly suited to open, windy locations because of the strong, thick 6\" tall scape that carries the flowers. The leaves and seed capsules persist well after the flowers have abscised and remain handsome until mid June.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed-propagated plants (accomplished as with "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(") require about 3 years to flower.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-moly")])]), _vm._v(" (mah' lee)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lily Leek, Golden Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-15\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Even before the time of Homer, the lily leek was endowed with magical properties. Reference to the “Moly” can be found in “The Odyssey”, in which Ulysses walked unharmed under its protection. It has been looked upon as a good luck charm for many years and this combination of magic and beauty makes the plant difficult not to include in the garden. Having said that, I have little success with these plants in my garden, perhaps because of the warm soil temperatures in the summer. The two flat, lancelike leaves are blue green and up to 2\" wide and 8-12\" long. The small 1/2\" star-shaped flowers are held in a 2\" wide, open umbel and possess a lovely shade of golden yellow. A dozen bulbs planted in a sunny well-drained area quickly increase to form a golden vista in late spring and early summer.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by bulb offsets or seed. Seed-propagated plants will flower in one year.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jeannine’ is a marked improvement on the species. She grows 12-18\" tall but is compact with bright yellow flowers, held on multiple scapes, in late spring.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-narcissiflorum")])]), _vm._v(" (nar-ciss-i-flo' rum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Narcissus Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/9\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Northern Italy, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("A wonderful dwarf species best suited for rock garden or a partially shaded nook in the garden. In bud, the flowers look like those of a small jonquil, but soon open to erect clusters of bright pink bell-shaped flowers. The 3-5 blue-green leaves are persistent through the season. This species and a few others ("), _c('em', [_vm._v("A. thunbergii")]), _vm._v(", "), _c('em', [_vm._v("A. tanguticum")]), _vm._v(") have small bulbs clustered together on a small rhizome.")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-neopolitanum")])]), _vm._v(" (nee-ah-pol-i-tay' num)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Naples Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two to three linear leaves, about 1/2 to 3/4\" wide and keeled, are held in a basal rosette resembling daffodil foliage. The scape carries a loose, many-flowered umbel (2 1/2\" across) of starry white flowers with rosy stamens. The individual flowers are about 3/4\" in diameter and are among the most fragrant in the genus. It is one of the earliest to flower, opening the end of April and persisting for about 4 weeks. Plants are not reliably hardy in zone 6, but if heavily mulched, will overwinter in zone 7a. Mulch should also be applied further south to reduce temperature fluctuations in the soil. Plant about 5\" deep in a sheltered corner of the garden, preferably at the foot of a low, south-facing wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fragrance of the flowers has made this a popular cut flower as well as an excellent species for greenhouse pot plant production. Cover 4-5 bulbs with an inch of soil in a 5\" diameter pot and place at 45°F for 8-10 weeks. Bring to a warm area and enjoy the flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("grandiflorum")]), _vm._v(" has 3\" diameter umbels consisting of white flowers with a dark eye. Plants are more vigorous than the species. It is used for forcing in pots and cut flower production and is more ornamental than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-nigrum")])]), _vm._v(" (nye' grum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Black Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe, North Italy")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bulbs produce 3-6 basal leaves in early spring and then send a long straight flower stem up to 3' in height. The many star-shaped white flowers are borne in a round 4-6\" wide umbel. Sometimes bulbils may form in the inflorescence. The ovary of each flower is dark green to black and appears to give the flowers a black center (thus the name "), _c('em', [_vm._v("nigrum")]), _vm._v("). The flowers occur relatively late in the spring and the seed heads remain highly ornamental for 3-4 additional weeks. These have been excellent additions to the Armitage garden, and persisted for about 3 years.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-oreophilum")])]), _vm._v(" (o-ray-o' fi-lum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mountain Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-12\"/9\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Afghanistan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is an excellent species for the patio planter or front of the garden. The 2-3 linear leaves are flat, bluish green, and somewhat limp. The dozens of star- to bell-shaped flowers are held in a 2\" diameter umbel. They have a mild pleasant fragrance though the pungent onion smell is particularly noticeable when the leaves and stem are crushed. The flowers persist for many weeks but become thin and papery as they age. The foliage is usually withered by flowering time or may persist for a week or so after flowering. Plant in a sunny, well-drained area.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Zwanenberg’ has carmine-pink flowers that are a little brighter than those of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-senescens")])]), _vm._v(" (sen-es' ens)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("German Garlic")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/6\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Northern Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cup-shaped flowers are clustered on a 1-2\" wide umbel in late spring to midsummer. The 4-9 basal green leaves are flat and somewhat grasslike. The plants are best for rock gardens or an area where the small plants will not get lost or overgrown. They tolerate full sun but a little afternoon shade is appreciated. The species itself is nothing to write home about, however, the variety sold as "), _c('em', [_vm._v("glaucum")]), _vm._v(" is popular and rather dramatic. The flowers are debatably more pink than in the species but the foliage is blue-green and twisted. Some authorities have named this variant "), _c('em', [_vm._v("A. spirale")]), _vm._v(" and it is known as the circle onion. They are not dramatic like ‘Globemaster’ but garner plenty of comments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Comments abound in the onion world about two cultivars—‘Summer Skies’ and ‘Blue Skies’. According to Mark McDonough, a well-respected allium breeder in Massachusetts, neither cultivar is particularly outstanding, and he adds that they are not “anything close to being blue flowered, but they do make nice foliage clumps.” Personally, I thought they were quite lovely, although not blue. Mature plants stand about 15\" tall. They appear to be happier in the North than the South where they produce many more leaves and far fewer flowers. They probably should be listed as cultivars of "), _c('em', [_vm._v("A. lusitanicum")]), _vm._v(" (formerly "), _c('em', [_vm._v("A. senescens")]), _vm._v(" var. "), _c('em', [_vm._v("montanum")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Roseum’ has pink flowers and if twisted leaves are not terribly important, then this is the best choice of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-schubertii")])]), _vm._v(" (shoo-ber' tea-eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Schubert Onion, Tumbleweed Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18-24\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mediterranean, Central Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0